// ─────────────────────────────────────────────────────────────────────────────
// notebooklmData.js — 통합 보고서 원칙 데이터 (before/after 예시 포함)
// ─────────────────────────────────────────────────────────────────────────────

export const CATEGORIES = [
  { id: 'all',            label: '전체',       icon: 'LayoutGrid'  },
  { id: '핵심 논리',      label: '핵심 논리',  icon: 'GitMerge'    },
  { id: '문서 구조',      label: '문서 구조',  icon: 'Layers'      },
  { id: '표현 문체',      label: '표현 & 문체', icon: 'Scissors'   },
  { id: '독자 중심',      label: '독자 중심',  icon: 'Users'       },
  { id: '시각화',         label: '시각화',     icon: 'BarChart2'   },
  { id: '실전 전략',      label: '실전 전략',  icon: 'Zap'         },
  { id: '심리·설득 전략', label: '심리·설득',  icon: 'Lightbulb'  },
  { id: '신뢰·검증',    label: '신뢰·검증',   icon: 'ShieldCheck' },
  { id: '디지털 실무',  label: '디지털 실무', icon: 'Smartphone'  },
  { id: '협업·프로세스', label: '협업',         icon: 'GitBranch'   },
  { id: '메타인지',     label: '메타인지',    icon: 'Brain'       },
];

export const CATEGORY_COLORS = {
  '핵심 논리':      'indigo',
  '문서 구조':      'cyan',
  '표현 문체':      'pink',
  '독자 중심':      'emerald',
  '시각화':         'rose',
  '실전 전략':      'amber',
  '심리·설득 전략': 'violet',
    '신뢰·검증':    'teal',
  '디지털 실무':  'sky',
  '협업·프로세스': 'orange',
  '메타인지':     'fuchsia',
};

export const UNIFIED_PRINCIPLES = [

  // ══════════════════════════════════════════
  // 📌 핵심 논리
  // ══════════════════════════════════════════
  {
    id: 1,
    category: "핵심 논리",
    title: "중복 없이, 빠짐 없이",
    subtitle: "중복 없이, 누락 없이",
    description: "항목들이 서로 중복되지 않으면서 전체를 빠짐없이 포괄해야 합니다. 문제를 쪼갤 때 교집합이 없어야 하며, 합치면 전체 집합이 되어야 합니다.",
    detail: "What Tree(무엇이?) → Why Tree(왜?) → How Tree(어떻게?)로 체계적으로 분석합니다.",
    icon: "Network",
    color: "indigo",
    memo: "�� 피자 8조각 법칙 — 겹치면 누군가 2조각, 빠지면 누군가 굶는다",
    beforeLabel: "중복·누락 있는 나열",
    afterLabel: "MECE 트리 구조",
    before: "원인 목록:\n• 팀장 역량 부족\n• 직원 사기 저하\n• 직원 교육 부족\n• 경쟁사 공세 심화\n• 홍보 예산 부족\n• 팀워크 부재\n(→ 중복·혼재, 무엇을 봐야 할지 모름)",
    after: "What?  매출 3분기 연속 하락\n  ↓\nWhy?   내부요인 / 외부요인\n  ↓\nHow?   단기 대책 / 중장기 전략\n(→ 겹치지 않고, 빠진 것도 없음)",
  },

  {
    id: 2,
    category: "핵심 논리",
    title: "결론을 맨 앞에",
    subtitle: "Bottom Line Up Front",
    description: "가장 중요한 결론과 실행 요청을 보고서 맨 앞에 배치합니다. 의사결정자의 집중력이 가장 높은 첫 순간에 핵심을 전달해야 합니다.",
    detail: "일의 진행 순서가 아닌 \"판단의 순서\"에 따라 정보를 배치하세요.",
    icon: "FastForward",
    color: "indigo",
    memo: "🎬 영화 예고편 — 결말을 먼저 보여주고 이유를 납득시킨다",
    beforeLabel: "귀납식 (결론이 맨 끝)",
    afterLabel: "BLUF (결론 선제시)",
    before: "1. 추진 배경 및 경위\n2. 현황 분석 (3페이지)\n3. 대안 검토 (A/B/C)\n4. 기대 효과 분석\n5. 결론 및 건의\n\n(→ 5번까지 읽어야 핵심을 앎)",
    after: "▶ 결론: B안 채택 건의 (예산 1.2억)\n   → 이유① 일정 단축 3개월\n   → 이유② 비용 절감 44%\n\n[근거 및 배경은 다음 장에]\n(→ 첫 줄에서 핵심 파악)",
  },

  {
    id: 3,
    category: "핵심 논리",
    title: "그래서 뭔데? 왜 그런데?",
    subtitle: "결론과 근거의 쌍방향 연결",
    description: "\"그래서 결론이 뭔데?(So What?)\"에 대답할 수 있어야 하며, 그 결론은 \"왜 그런데?(Why So?)\"라는 논리적 근거로 명확히 뒷받침되어야 합니다.",
    detail: "위로 올라갈 때는 So What, 아래로 내려갈 때는 Why So를 반복적으로 자문하세요.",
    icon: "GitMerge",
    color: "indigo",
    memo: "🏓 탁구 왕복 — 'Because↑' 'So↓' 를 위아래로 핑퐁 치며 검증",
    beforeLabel: "사실 나열 (해석 없음)",
    afterLabel: "So What → Why So 연결",
    before: "3분기 매출이 전년 대비\n하락하였습니다.\n고객 만족도도 다소\n하락한 것으로 나타났습니다.\n\n(→ \"그래서 뭐?\"가 없음)",
    after: "So What:\n  3분기 매출 –12%\n  → 연간 목표 미달 확실시\n\nWhy So:\n  • 원자재비 +35%\n  • 경쟁사 신제품 출시 2건\n\n(→ 원인-결론이 연결됨)",
  },

  {
    id: 4,
    category: "핵심 논리",
    title: "가설 먼저, 검증 나중",
    subtitle: "가설 설정 → 신속 검증",
    description: "막연한 사실 나열이 아닌, \"이것이 문제일 것이다\"라는 사전 가설을 먼저 세우고 검증해 나가는 전개 방식을 택해야 합니다.",
    detail: "광활한 데이터를 처음부터 무작정 뒤지기보다, 가설을 먼저 세우고 최소한의 팩트만 빠르게 수집하세요.",
    icon: "Lightbulb",
    color: "indigo",
    memo: "🎯 과녁 먼저, 화살 나중 — 목표 없이 데이터만 모으지 마라",
    beforeLabel: "데이터 → 분석 → 결론 (느림)",
    afterLabel: "가설 → 검증 → 확인 (빠름)",
    before: "① 모든 판매 데이터 수집 (3개월)\n② 지역별·상품별 교차 분석\n③ 외부 환경 조사\n④ 내부 역량 조사\n⑤ 결론 도출\n\n(→ 3개월이 걸림)",
    after: "가설: \"가격 경쟁력이 이탈 원인\"\n\n검증: 이탈 고객 100명 인터뷰\n결과: 가설 기각 → 배송 속도가 진짜 이유\n\n(→ 2주 안에 방향 확정)",
  },

  {
    id: 23,
    category: "핵심 논리",
    title: "피라미드 논리 구조",
    subtitle: "결론 → 근거 → 데이터 순으로 내려가라",
    description: "바바라 민토가 정립한 글쓰기 구조. 결론을 최상단에 두고, 그 아래에 근거 묶음, 그 아래에 데이터를 배치합니다. 위에서 아래로 읽어도, 아래에서 위로 올라가도 논리가 연결되어야 합니다.",
    detail: "각 레벨 항목들은 MECE여야 하고, 상위 항목을 아래 항목들이 논리적으로 지지해야 합니다.",
    icon: "GitMerge",
    color: "indigo",
    memo: "🏃 수동 말고 능동 — '뛰어졌다' 말고 '뛰었다'",
    beforeLabel: "귀납식 (결론이 묻힘)",
    afterLabel: "피라미드 (결론이 꼭대기)",
    before: "데이터 A: 시장 점유율 하락\n데이터 B: 고객 이탈율 증가\n데이터 C: 경쟁사 성장\n데이터 D: 가격 경쟁력 약화\n\n결론: 전략 재수립이 필요하다\n\n(→ 결론이 4개 데이터 뒤에 숨음)",
    after: "결론: 전략 재수립이 시급하다\n  ↓\n근거①: 외부 위협 증가\n  - 경쟁사 성장, 가격 약화\n근거②: 내부 성과 저하\n  - 점유율 하락, 이탈율 증가\n\n(→ 첫 줄에 결론, 아래에 근거)",
  },

  {
    id: 24,
    category: "핵심 논리",
    title: "논리 위아래 확인법",
    subtitle: "\"그래서(So)?\"와 \"왜냐하면(Because)?\"을 교차 검증",
    description: "피라미드 구조를 완성하면 위에서 아래로 \"왜냐하면?\"을 물어보고, 아래에서 위로 \"그래서?\"를 물어보며 논리가 끊어지지 않는지 검증하세요.",
    detail: "어느 방향으로 읽어도 말이 되어야 진짜 논리적인 문서입니다.",
    icon: "Network",
    color: "indigo",
    memo: "🍡 꼬치 하나에 하나 — 두 개 꽂으면 한 개가 떨어진다",
    beforeLabel: "논리 단절 (검증 안 함)",
    afterLabel: "상하 테스트 통과",
    before: "결론: 영업 전략을 바꿔야 한다\n  ↓\n근거: 고객 서비스가 불친절하다\n  ↓\n데이터: 매출이 15% 하락했다\n\n(→ 매출 하락이 왜 불친절 근거?\n    논리 연결이 끊김)",
    after: "결론: 영업 전략 교체 필요\n  ↓ (왜냐하면?)\n근거①: 신규 고객 유입 -30%\n  ↓ (왜냐하면?)\n데이터: 디지털 채널 전환율 2%\n\n위로 ↑ \"그래서?\" 검증도 통과",
  },

  {
    id: 49,
    category: "핵심 논리",
    title: "왜? 를 5번 물어라",
    subtitle: "\"왜?\"를 5번 물으면 근본 원인이 나온다",
    description: "문제의 표면적 현상을 치료하면 재발합니다. \"왜?\"를 다섯 번 반복해 숨겨진 진짜 원인을 파헤쳐야 혁신적인 해결책이 나옵니다.",
    detail: "기획의 정석 핵심 기법. 첫 번째 Why의 답이 다음 Why의 질문이 됩니다. 5번째 Why에서 근본 원인이 드러납니다.",
    icon: "Search",
    color: "indigo",
    memo: "🪞 거울의 역설 — 시금치가 내 이에 끼어도 나는 못 본다",
    beforeLabel: "표면 해결 (재발 반복)",
    afterLabel: "5 Why 근본 원인 도출",
    before: "문제: 명함을 줘도 버린다\n\n해결책: 명함 디자인을 예쁘게 바꾸자\n\n(→ 6개월 후 같은 문제 재발\n    진짜 원인을 모른 채 치료)",
    after: "Why① 명함을 버린다\nWhy② 특징이 없어서\nWhy③ 이름·번호만 있어서\nWhy④ 차별화 요소가 없어서\nWhy⑤ 가치를 전달 못해서\n\n→ 해결: 두 명함이 합치면 입체 강아지!\n   (차별화 + 기억에 남는 경험)",
  },

  {
    id: 50,
    category: "핵심 논리",
    title: "결론부터 피라미드로",
    subtitle: "결론→근거→세부 데이터 3층 구조",
    description: "최상단에 결론(핵심 메시지), 중간에 3가지 핵심 논거, 하단에 구체적 데이터와 사례를 배치합니다. 하위 항목들이 상위 메시지를 탄탄히 받쳐주면 설득력이 극대화됩니다.",
    detail: "바바라 민토(McKinsey)가 정립한 원칙. 보고서의 어떤 단락이든 \"위로 올라가면 So What, 아래로 내려가면 Why So\"가 성립해야 합니다.",
    icon: "Triangle",
    color: "indigo",
    memo: "⏰ 알람 설명서 — 울리는 이유를 써야 끄고 싶어진다",
    beforeLabel: "평면적 나열 (층위 없음)",
    afterLabel: "피라미드 3층 구조",
    before: "매출 하락 분석\n• 영업인력 이탈 3명\n• 경쟁사 신제품 출시\n• 마케팅 예산 20% 삭감\n• 고객 CS 만족도 하락\n• 물류비용 증가\n\n(→ 같은 층위에 섞여\n    어디서 시작해야 할지 모름)",
    after: "결론: \"내부 역량 저하\"가 핵심 원인\n├─ 논거①: 영업력 약화\n│   └─ 이탈 3명 + CS 하락\n├─ 논거②: 비용 구조 악화\n│   └─ 예산 삭감 + 물류비↑\n└─ 논거③: 경쟁 환경 변화\n    └─ 경쟁사 신제품 2건\n(→ 한 눈에 우선순위 파악)",
  },

  // ══════════════════════════════════════════
  // 📌 문서 구조
  // ══════════════════════════════════════════
  {
    id: 5,
    category: "문서 구조",
    title: "3단·4단 구조",
    subtitle: "현황→원인→대책 / 제목→개요→본론→말미",
    description: "어떤 이슈도 \"현황→원인→대책\" 3단계, 공식 문서는 \"제목→개요→본론→말미\" 4단 골격으로 구성해야 합니다.",
    detail: "결론부는 단순 요약이 아닌, 예산·인원·일정 등 구체적 실행 계획을 포함해야 합니다.",
    icon: "Layers",
    color: "cyan",
    memo: "🏛️ 이집트 피라미드 — 결론이 꼭대기, 데이터가 맨 아래",
    beforeLabel: "구조 없는 나열",
    afterLabel: "4단 골격 적용",
    before: "작년 신규 고객 수는 1,245명이었으며\n당사는 오랜 역사를 자랑하고...\n시장 환경이 변화하는 가운데...\n직원들의 노력으로...\n(→ 무엇을 요청하는지 모름)",
    after: "① 제목:  신규 고객 30% 증대 방안 (안)\n② 개요:  디지털 전환으로 연 3천 명 목표\n③ 본론:  현황 / 원인 / 3가지 대책\n④ 말미:  ○○팀, 5/1까지\n          예산 5천만 원 승인 요청",
  },

  {
    id: 6,
    category: "문서 구조",
    title: "한 장에 한 가지만",
    subtitle: "1보고서 = 1주제",
    description: "한 장의 슬라이드에는 오직 하나의 굵직한 메시지만 담습니다. 하나의 보고서에는 반드시 1개의 주제만 다뤄야 합니다.",
    detail: "주제가 2개라면 보고서도 2개로 분리하는 것이 정석입니다.",
    icon: "FileText",
    color: "cyan",
    memo: "🚗 내비 재탐색 — 출발지·도착지 양쪽에서 경로를 검증한다",
    beforeLabel: "한 보고서에 여러 주제",
    afterLabel: "주제별 분리",
    before: "[3분기 종합 현안 보고서]\n• 매출 부진 원인 분석\n• 신규 채용 지연 문제\n• IT 시스템 노후화 대책\n• 고객 CS 불만 급증\n\n(→ 뭘 결정하라는 건지 모름)",
    after: "보고서 A: 3분기 매출 부진 원인\n보고서 B: 신규 채용 지연 대책\n보고서 C: IT 시스템 교체 계획\n보고서 D: CS 불만 감소 방안\n\n(→ 각각 명확한 결정 요청)",
  },

  {
    id: 7,
    category: "문서 구조",
    title: "제목 작성법 — 8초 법칙",
    subtitle: "목적 + 기대효과 숫자를 담아라",
    description: "보고서 제목은 \"~을 위한 ~(안)\" 형태로, 기대 효과를 나타내는 숫자를 포함하세요. 제목만 봐도 목적과 결론을 파악할 수 있어야 합니다.",
    detail: "의사결정권자의 집중력은 첫 8초가 승부입니다.",
    icon: "Type",
    color: "cyan",
    memo: "🧅 양파 껍질 — 왜? 를 5번 까야 진짜 속이 나온다",
    beforeLabel: "막연한 제목",
    afterLabel: "효과 + 목적 포함",
    before: "구매 프로세스 개선 방안\n\n(→ 왜 봐야 하는지 모름\n   승인할 이유가 안 보임)",
    after: "연간 3억 절감을 위한\n구매 프로세스 개선 방안 (안)\n\n(→ \"3억 절감\"이 눈에 들어옴\n   읽어야 할 이유가 명확)",
  },

  {
    id: 8,
    category: "문서 구조",
    title: "실행 항목을 명확히 써라",
    subtitle: "누가, 언제까지, 무엇을",
    description: "문제를 제기했으면 \"누가, 언제까지, 무엇을 할 것인가?\"를 명시해야 책임 소재가 분명해집니다.",
    detail: "원인 분석에서 끝나는 보고서는 반쪽짜리입니다.",
    icon: "Target",
    color: "cyan",
    memo: "🎂 3단 케이크 — 1층 데이터, 2층 근거, 맨 위에 결론 장식",
    beforeLabel: "모호한 마무리",
    afterLabel: "구체적 실행 계획",
    before: "향후 지속적인 개선 활동이\n필요할 것으로 사료됩니다.\n\n관련 부서의 협조를 바랍니다.\n\n(→ 아무도 안 움직임)",
    after: "□ 마케팅팀  SNS 광고 강화   4/30  김팀장\n□ 영업팀    가격 재협상     5/15  이부장\n□ 기획팀    성과 보고 작성  5/31  박과장\n\n예산: 5천만 원 (별도 승인 요청)",
  },

  {
    id: 25,
    category: "문서 구조",
    title: "경영진용 한 장 요약",
    subtitle: "바쁜 임원은 첫 장만 읽는다",
    description: "5장짜리 보고서라도 반드시 1페이지짜리 Executive Summary를 앞에 붙이세요. 결론, 주요 근거 2~3개, 실행 요청 사항만 담습니다.",
    detail: "임원 입장에서 \"이게 요점이구나\"를 1분 이내에 파악할 수 있어야 합니다.",
    icon: "FileText",
    color: "cyan",
    memo: "📏 같은 줄자만 쓰기 — 처음부터 끝까지 같은 단위로 재야 한다",
    beforeLabel: "요약 없이 바로 본문",
    afterLabel: "1페이지 요약 선제시",
    before: "1장: 추진 배경 (2p)\n2장: 현황 분석 (3p)\n3장: 대안 검토 (4p)\n4장: 실행 계획 (3p)\n5장: 기대 효과 (1p)\n\n(→ 임원이 13장을 전부 읽어야\n     핵심을 파악 가능)",
    after: "【요약】(1p)\n핵심 결론: B안 채택 건의\n주요 근거: ① 비용 44% 절감\n            ② 일정 3개월 단축\n요청 사항: 예산 1.2억 승인\n\n【상세 내용】(12p) → (아래 장부터)\n(→ 임원은 1장만, 실무자는 13장 모두)",
  },

  {
    id: 26,
    category: "문서 구조",
    title: "결재 단계별 분량 기준",
    subtitle: "임원 1장, 팀장 3장, 실무 5장 이내",
    description: "보고서의 적정 분량은 제출 대상에 따라 다릅니다. 올라갈수록 더 짧고, 더 굵게 써야 합니다.",
    detail: "\"많이 쓰면 성의 있게 보인다\"는 오해가 장황한 보고서를 만드는 원흉입니다.",
    icon: "Layers",
    color: "cyan",
    memo: "🧑‍⚖️ 법정 증언 방식 — '사실은 ~이고, 제 판단은 ~입니다' 를 구분",
    beforeLabel: "무조건 상세하게 (모두 동일)",
    afterLabel: "대상별 분량 차별화",
    before: "대표이사 보고서: 20장\n본부장 보고서:  18장\n팀장 보고서:    15장\n\n\"열심히 한 티를 내야 해서...\"\n\n(→ 읽기 전에 이미 피로감)",
    after: "대표이사: 1장 (핵심+요청만)\n본부장:   3장 (+ 근거 요약)\n팀장:     5장 (+ 실행 계획)\n실무자:   제한 없음 (전체 상세)\n\n(→ 각 단계에 필요한 깊이만)",
  },

  {
    id: 27,
    category: "문서 구조",
    title: "스토리라인 목차 설계",
    subtitle: "목차만 읽어도 스토리가 흘러야 한다",
    description: "목차 항목들이 단순 분류가 아닌, 논리 흐름을 갖는 \"문장\"처럼 읽힐 때 보고서의 설득력이 올라갑니다.",
    detail: "좋은 목차는 보고서를 읽지 않아도 논거의 흐름이 납득되어야 합니다.",
    icon: "BookOpen",
    color: "cyan",
    memo: "🎵 편곡의 법칙 — 원곡(상사 언어) 살리며 새 악기 하나만 더한다",
    beforeLabel: "분류형 목차 (스토리 없음)",
    afterLabel: "서사형 목차 (스토리 흐름)",
    before: "1. 현황\n2. 문제점\n3. 원인\n4. 해결방안\n5. 기대효과\n\n(→ 어느 보고서에나 쓸 수 있는\n    무의미한 구조)",
    after: "1. 매출이 2분기 연속 하락 중\n2. 핵심 원인: 신규채널 부재\n3. 3가지 채널 확대 전략\n4. 6개월 내 매출 20% 회복 목표\n\n(→ 목차만 읽어도 논리가 완성됨)",
  },

  {
    id: 45,
    category: "문서 구조",
    title: "별첨 활용법",
    subtitle: "본문 = 결론 3줄, 별첨 = 세부 전체",
    description: "세부 데이터·인터뷰 원문·산출 근거 등은 별첨으로 분리하세요. 본문에는 판단에 필요한 핵심 인사이트만 남겨 집중력을 지킵니다.",
    detail: "\"별첨 X 참조\"라고 쓰면 독자가 직접 찾아볼 수 있습니다. 본문에 다 넣으면 아무도 핵심을 찾지 못합니다.",
    icon: "Layers",
    color: "cyan",
    memo: "🎣 낚시 타이밍 — 물고기가 수면에 올라왔을 때 낚싯대를 던진다",
    beforeLabel: "본문에 데이터가 가득",
    afterLabel: "본문 = 핵심 / 별첨 = 세부",
    before: "본문에 모두 포함:\n지역별·상품별·월별 교차 분석표\n직원 전체 인터뷰 결과 (50p)\n원자료 출처 목록 (10p)\n\n(→ 핵심이 데이터에 묻힘\n    무엇을 결정해야 하는지 모름)",
    after: "본문: 핵심 인사이트 3줄 + 결론\n\n[별첨 1] 데이터 교차 분석 (7p)\n[별첨 2] 인터뷰 전문 (50p)\n[별첨 3] 참고자료 목록\n\n(→ 필요한 사람만 별첨 열람\n    본문은 1분 안에 파악)",
  },

  {
    id: 51,
    category: "문서 구조",
    title: "한 장 기획서",
    subtitle: "8개 항목으로 승인을 끌어내는 압축 기획서",
    description: "패트릭 라일리의 1 Page Proposal은 제목·부제·목표·2차목표·논리적 근거·재정·현재상태·실행 8개 항목으로 모든 기획을 한 장에 압축합니다.",
    detail: "한 장으로 쓰지 못한다면 아직 기획이 완성되지 않은 것입니다. 의사결정자의 시간을 아끼고 빠른 결정을 돕기 위해 반드시 압축하세요.",
    icon: "FileText",
    color: "cyan",
    memo: "🧩 3피스 퍼즐 — 상황·문제·해결, 3개 다 맞아야 그림이 완성된다",
    beforeLabel: "두꺼운 기획서 (읽히지 않음)",
    afterLabel: "1 Page Proposal 8항목",
    before: "표지 1장\n목차 1장\n추진 배경 및 경위 3장\n현황 분석 5장\n대안 비교 4장\n기대효과 2장\n추진 일정 2장\n예산 계획 2장\n\n(→ 총 20장, 결재자가 끝까지\n    읽지 않아 반려 반복)",
    after: "① 제목: A 시스템 도입 제안\n② 부제: 운영비 40% 절감\n③ 목표: 2025년 내 인프라 현대화\n④ 2차 목표: 업무 속도 3배 향상\n⑤ 근거: 현황→문제→해결 3단 논리\n⑥ 재정: 초기비용 2억, ROI 18개월\n⑦ 현재 상태: 파일럿 완료, 승인 대기\n⑧ 실행 요청: 예산 승인 요청\n(→ 1장, 3분 안에 결재 가능)",
  },

  {
    id: 52,
    category: "문서 구조",
    title: "1보고서 1주제 원칙",
    subtitle: "한 문서에 두 가지 의제를 넣지 마라",
    description: "하나의 보고서 안에 여러 사안을 섞으면 독자가 집중력을 잃고 결재가 지연됩니다. 사안마다 별도의 보고서로 완전히 분리하세요.",
    detail: "청와대 비서실 & 삼성 공통 원칙. \"이 보고서가 요청하는 결정이 무엇인가?\"를 한 문장으로 말할 수 없다면 분리해야 합니다.",
    icon: "Layers",
    color: "cyan",
    memo: "🌱 물 준 화분 — 심은 뒤 방치하면 죽는다, 후속 점검이 물주기",
    beforeLabel: "여러 의제 혼합 (결재 지연)",
    afterLabel: "1건 1보고서 (즉각 처리)",
    before: "[2025년 2분기 종합 보고]\n\n1. A사업 예산 추가 요청 (3억)\n2. B사업 결과 보고\n3. C사업 인력 충원 요청\n4. 하반기 사업 계획 수정 안\n\n(→ 무엇을 결재해야 하는지\n    혼란 → 전체 보류)",
    after: "[A사업] 예산 추가 요청 건 ← 별도 1장\n[B사업] 3분기 결과 보고 ← 별도 1장\n[C사업] 인력 충원 요청 ← 별도 1장\n[전략] 하반기 계획 수정 ← 별도 1장\n\n(→ 각 건별 즉각 결재 가능\n    처리 속도 4배 향상)",
  },

  // ══════════════════════════════════════════
  // 📌 표현 문체
  // ══════════════════════════════════════════
  {
    id: 9,
    category: "표현 문체",
    title: "숫자로 증명하라",
    subtitle: "형용사 배제, 추상어 → 수치로 전환",
    description: "\"매우 위험하다\", \"크게 개선되었다\" 대신 \"전년 대비 15% 하락\", \"비용 2억 원 절감\" 등 구체적인 숫자로 입증해야 합니다.",
    detail: "숫자는 가장 건조하지만 가장 강력한 무기입니다.",
    icon: "BarChart3",
    color: "pink",
    memo: "🚦 신호등 — 현황(빨강)→원인(노랑)→대책(초록) 순으로",
    beforeLabel: "형용사 범벅 (모호)",
    afterLabel: "수치 기반 (명확)",
    before: "상당한 성과를 달성하였으며\n고객 만족도가 크게 향상되었습니다.\n\n매출도 많이 늘었고\n비용도 상당히 절감되었습니다.\n\n(→ \"상당히\"가 얼만지 모름)",
    after: "NPS: 62점 → 78점  (+26%)\n재구매율: 41% → 55%  (+14%p)\n\n매출: +18억 (전년비 +15%)\n비용 절감: 2억 원\n\n(→ 숫자가 모든 것을 말함)",
  },

  {
    id: 10,
    category: "표현 문체",
    title: "개조식 문체",
    subtitle: "명사형 끊기 + 기호 활용",
    description: "\"~할 수 있을 것으로 사료됩니다\" 같은 소극적 문장을 피하고, 능동태와 명사형 종결로 짧고 당당하게 끊어 치는 문장을 사용하세요.",
    detail: "한 문장은 2~3줄 이내, 불필요한 조사와 수식어를 걷어내고 기호(□, ○, -)를 활용합니다.",
    icon: "AlignLeft",
    color: "pink",
    memo: "🍜 한 그릇에 한 메뉴 — 짜장면 위에 피자 올리면 둘 다 망한다",
    beforeLabel: "서술식 (길고 힘없음)",
    afterLabel: "개조식 (짧고 명확)",
    before: "이번 프로젝트에서는 대다수의\n고객들로부터 긍정적인 반응을\n얻을 수 있었으며, 전반적으로\n만족스러운 결과를 도출했다고\n볼 수 있습니다.\n(→ 핵심이 어디있는지 모름)",
    after: "□ 고객 반응 (전년 동기 대비)\n  - NPS: 62점 → 78점  (+26%)\n  - 재구매율: 41% → 55%\n  - 불만 건수: 120 → 74건 (↓38%)\n(→ 한눈에 파악)",
  },

  {
    id: 11,
    category: "표현 문체",
    title: "용어 통일",
    subtitle: "동일 대상, 하나의 이름으로",
    description: "동일 대상을 \"고객\", \"User\", \"사용자\"로 섞어 쓰지 마세요. 표준 용어로 완전히 통일해야 가독성이 극대화됩니다.",
    detail: "조직 고유의 약어나 업계 표준 명칭으로 치환하는 작업은 필수 퇴고 과정입니다.",
    icon: "BookOpen",
    color: "pink",
    memo: "📺 뉴스 헤드라인 — '삼성 영업이익 23% 급증' 처럼 숫자+결과 제목",
    beforeLabel: "혼재 (혼란 유발)",
    afterLabel: "통일 (가독성 향상)",
    before: "고객이 user로 전환될 경우\n사용자 불만이 급증하고,\nCustomer 이탈이 예상됨.\n\n이용자의 경험을 개선해야\n회원 유지율이 높아질 것.\n\n(→ 같은 대상인데 5가지 단어)",
    after: "[용어 정의]\n  고객 = 외부 서비스 이용자\n  사용자 = 내부 시스템 운영자\n\n\"고객 이탈 방지를 위해\n 고객 경험 개선이 필요함.\"\n\n(→ 읽으면서 해석 불필요)",
  },

  {
    id: 12,
    category: "표현 문체",
    title: "초안은 빠르게, 수정은 정밀하게",
    subtitle: "목차 먼저 → 살 나중",
    description: "처음부터 완벽한 문장을 다듬으려 하지 마세요. 핵심 키워드 중심의 구조(목차)를 먼저 합의받은 후 살을 붙여가세요.",
    detail: "OK 사인 받고 살 붙이는 게 엎어짐을 막는 비결입니다.",
    icon: "Zap",
    color: "pink",
    memo: "📬 택배 라벨 — 누가·언제까지·어디로 없으면 미배달 처리",
    beforeLabel: "완성 후 공유 (위험)",
    afterLabel: "목차 먼저 공유 (안전)",
    before: "며칠 동안 혼자 작성\n↓\n상세 보고서 완성\n↓\n공유했더니 \"방향이 달라\"\n↓\n처음부터 다시 작성\n\n(→ 3일 공수 낭비)",
    after: "Day 1: 목차(뼈대)만 공유\n        → \"방향 맞지요?\" 확인\nDay 2: OK 받고 살 붙이기 시작\nDay 3: 완성\n\n(→ 엎어질 일이 없음)",
  },

  {
    id: 28,
    category: "표현 문체",
    title: "능동태 글쓰기",
    subtitle: "\"~될 예정입니다\" → \"~합니다\"",
    description: "수동태는 책임 소재를 흐리게 하고, 문장을 늘어지게 만듭니다. 주어를 명확히 하고 능동형 동사를 쓰세요.",
    detail: "\"고려될 수 있을 것으로 사료됩니다\" → \"검토하겠습니다\" — 한 문장이 5단어 줄어들고 뜻은 더 명확해집니다.",
    icon: "Type",
    color: "pink",
    memo: "🍽️ 식당 메뉴판 — 주방장이 먹고 싶은 게 아니라 손님이 먹고 싶은 것",
    beforeLabel: "수동태 (책임자 불명확)",
    afterLabel: "능동태 (주체 명확)",
    before: "예산안이 검토될 예정이며,\n추후 관련 부서에 배분될 것으로\n사료됩니다.\n\n(→ 누가? 언제? 가 없음\n    책임자도 불명확)",
    after: "기획팀이 예산안을 검토하고\n3/31까지 각 부서에 배분합니다.\n\n(→ 주체·시점이 명확)",
  },

  {
    id: 29,
    category: "표현 문체",
    title: "1문장 1아이디어 원칙",
    subtitle: "50자 넘으면 쪼개라",
    description: "한 문장에 두 가지 이상의 아이디어를 욱여넣지 마세요. 읽다가 기억이 리셋됩니다. 문장 하나가 생각 하나를 담아야 합니다.",
    detail: "접속사(그러므로, 따라서, 하지만)가 한 문장 안에 2개 이상 보이면, 즉시 문장을 분리하세요.",
    icon: "AlignLeft",
    color: "pink",
    memo: "🍦 아이스크림 가게 — '뭐 드릴까요?' 대신 '딸기·초코·바닐라 중 하나'",
    beforeLabel: "복합 문장 (과부하)",
    afterLabel: "단문 분리 (가독성)",
    before: "이번 프로젝트는 예산 초과로\n인해 일부 기능이 축소되었음에도\n불구하고, 고객 만족도는 오히려\n상승하였는데 이는 UX 개선 덕분인\n것으로 사료됩니다.\n\n(→ 한 번에 세 가지 내용)",
    after: "예산 초과로 기능 일부 축소.\n그럼에도 고객 만족도 +12%.\n원인: UX 개선 효과.\n\n(→ 세 문장, 세 아이디어로 분리)",
  },

  {
    id: 30,
    category: "표현 문체",
    title: "숫자 표기 일관성",
    subtitle: "단위·기준·소수점을 처음부터 통일",
    description: "같은 보고서 안에서 \"3억\", \"300,000천 원\", \"3억원\"이 혼재하면 신뢰가 무너집니다. 첫 장에 단위 기준표를 명시하거나, 전체적으로 통일하세요.",
    detail: "기준선이 다른 두 수치를 비교 그래프에 함께 넣으면 의사결정자를 오도할 수 있습니다.",
    icon: "BarChart3",
    color: "pink",
    memo: "✈️ 파일럿 체크리스트 — 6개 다 확인 안 하면 이륙 불가",
    beforeLabel: "단위 혼재 (혼란)",
    afterLabel: "단위 통일 (신뢰)",
    before: "1분기 매출: 3억\n2분기 매출: 350,000천 원\n3분기 매출: 4억원\n4분기 목표: 400 (백만)\n\n(→ 4가지 단위가 혼재\n    4분기가 얼마인지 계산해야 함)",
    after: "【단위: 억 원】\n1분기: 3.0억\n2분기: 3.5억\n3분기: 4.0억\n4분기 목표: 4.0억\n\n(→ 첫 줄에 기준 명시\n    비교가 즉시 가능)",
  },

  {
    id: 53,
    category: "표현 문체",
    title: "사실과 의견을 구분해서 써라",
    subtitle: "주관적 판단을 객관적 사실처럼 쓰지 마라",
    description: "보고자의 주관적 판단을 사실처럼 묘사하면 의사결정자가 왜곡된 정보로 잘못된 결정을 내립니다. 사실(Fact)과 의견(Opinion)을 명확히 구분해 작성하세요.",
    detail: "청와대 비서실 핵심 원칙. \"우려됩니다\" \"심각합니다\" 같은 표현이 나오면 반드시 근거 수치로 뒷받침하거나 [의견] 표시를 붙이세요.",
    icon: "Scale",
    color: "pink",
    memo: "⚓ 배의 닻 — 처음 던진 숫자가 바닥에 박혀 판단 범위를 결정한다",
    beforeLabel: "사실·의견 혼재 (오판 유발)",
    afterLabel: "사실·의견 명확 분리",
    before: "\"경쟁사 신제품의 성능이 월등히\n뛰어나 당사 매출 타격이 매우\n심각할 것으로 우려됨.\"\n\n(→ \"월등히\" \"매우\" \"심각\"이\n    수치 없이 주관적 공포 전달\n    → 과잉 대응 or 무시 위험)",
    after: "[사실] 경쟁사 신제품 처리속도\n       당사 대비 15% 우위\n\n[의견·전망] 대응책 부재 시\n       전년 대비 매출 -10% 예상\n       (근거: 유사 사례 2건 분석)\n\n(→ 팩트와 판단이 명확히 분리)",
  },

  {
    id: 54,
    category: "표현 문체",
    title: "상사의 언어 80% + 새로움 20%",
    subtitle: "낯선 언어는 심리적 장벽을 만든다",
    description: "상사가 평소 자주 쓰는 표현과 회사 경영방침 키워드를 80% 활용하고, 새로운 아이디어는 20%로 절제하세요. 낯설지 않아야 설득됩니다.",
    detail: "삼성형 보고서 원칙. 경영진의 신년사·사업 계획서에서 핵심 키워드를 추출하여 보고서에 자연스럽게 녹여내세요.",
    icon: "MessageSquare",
    color: "pink",
    memo: "😱 지갑 도난의 법칙 — '10만원 번다'보다 '10만원 잃는다'가 심장이 더 쿵",
    beforeLabel: "생소한 언어 (장벽 발생)",
    afterLabel: "상사 언어 + 새 아이디어 융합",
    before: "\"MZ세대 페르소나 기반\nOMO 전략으로 리텐션과\nLTV를 극대화하겠습니다.\"\n\n(→ 임원이 처음 듣는 단어들\n    \"무슨 말인지 모르겠어\" 반응\n    → 기획 자체가 거부됨)",
    after: "\"고객 충성도 강화(기존 언어)를\n위해 온·오프라인 통합 접점에서\n재방문율을 높이겠습니다.\n\n구체적으로, 신규 기법인 ○○을\n적용하면 재방문율 20% 제고\n기대합니다.(새로움 20%)\n\n(→ 익숙한 언어로 공감 먼저)",
  },

  // ══════════════════════════════════════════
  // 📌 독자 중심
  // ══════════════════════════════════════════
  {
    id: 13,
    category: "독자 중심",
    title: "읽는 사람 중심으로",
    subtitle: "내가 쓰고 싶은 글 → 그가 읽고 싶은 글",
    description: "\"내가 하고 싶은 말\"이 아니라 \"그가 읽고 싶어 하고 우려하는 부분\"을 중심으로 설계해야 합니다.",
    detail: "의사결정자가 가장 먼저 태클 걸 만한 내용을 선제적으로 FAQ 형태로 해소해야 합니다.",
    icon: "Users",
    color: "emerald",
    memo: "☕ 커피 한 잔 시간 — 임원은 커피 식기 전에 판단을 끝낸다",
    beforeLabel: "작성자 중심 순서",
    afterLabel: "결재자 중심 순서",
    before: "1. 추진 경과 (내가 한 일)\n2. 세부 활동 내역\n3. 팀원별 기여도\n4. 향후 계획\n5. 결론 및 기대 효과\n\n(→ 결재자 관심사가 맨 끝)",
    after: "1. 승인 요청 사항 (예산/인원)\n2. 기대 효과 (ROI)\n3. 리스크와 대책\n4. 타임라인\n5. 세부 내역 (첨부)\n\n(→ 첫 눈에 \"무엇을, 왜 승인해야 하는지\" 명확)",
  },

  {
    id: 14,
    category: "독자 중심",
    title: "선택지 떠먹여 주기",
    subtitle: "\"어떻게 할까요?\" 대신 A안 vs B안",
    description: "장단점을 대비한 대안(A안, B안)을 제시하고, 본인의 논리가 담긴 최종 추천안을 담아 올려야 합니다.",
    detail: "객관적 의사결정 재료를 제공하면서도 실무자의 소신이 담겨 있어야 합니다.",
    icon: "SplitSquareHorizontal",
    color: "emerald",
    memo: "🐟 물고기 크기에 맞는 그릇 — 임원=1장, 팀장=3장, 실무=5장",
    beforeLabel: "\"알아서 해주세요\"",
    afterLabel: "A vs B → 추천안 제시",
    before: "개발 방식에 대해\n어떻게 진행하면 좋을지\n의견을 주시면 검토 후\n진행하겠습니다.\n\n(→ 결재자가 직접 생각해야 함)",
    after: "A안: 직접 개발   2억 원   6개월\nB안: 외주 개발   1.2억   3개월\n\n→ 추천: B안\n   이유: 일정 리스크 ↓, 비용 44%↓\n   리스크: 품질 관리 필요",
  },

  {
    id: 15,
    category: "독자 중심",
    title: "육하원칙 체크리스트",
    subtitle: "초보자의 만능 점검표",
    description: "보고서를 처음 쓴다면 \"누가, 언제, 어디서, 무엇을, 어떻게, 왜\"가 다 들어있는지 먼저 점검하세요.",
    detail: "특히 \"왜(추진 배경)\"와 \"어떻게(실행 방안)\"가 빠져 기각당하는 경우가 가장 흔합니다.",
    icon: "Key",
    color: "emerald",
    memo: "📖 만화 목차 — 회차 제목만 봐도 줄거리가 보여야 한다",
    beforeLabel: "6가지 중 2개 누락",
    afterLabel: "6가지 모두 포함",
    before: "\"SNS 마케팅을 강화하기로\n 했습니다.\"\n\n(→ 누가? 언제? 얼마나?\n    왜 지금? 어떻게? 가 없음)",
    after: "Who:  마케팅팀 박대리\nWhat: 인스타그램 광고 집행\nWhen: 5/1 ~ 5/31\nWhere: 인스타그램\nHow:  일 50만 원 예산\nWhy:  2030 신규 유입 확대",
  },

  {
    id: 16,
    category: "독자 중심",
    title: "나쁜 소식을 먼저 말해라",
    subtitle: "핑계 없는 빠른 실토",
    description: "사고나 리스크를 보고할 때는 배경과 변명으로 밑장 빼기를 하지 마세요. 최악의 소식을 1초라도 빨리 올려야 수습 골든타임을 확보합니다.",
    detail: "상황 요약 최상단에 피해 규모와 본질을 명시하고, 수습 방안을 바로 뒤에 붙이세요.",
    icon: "AlertTriangle",
    color: "emerald",
    memo: "🧾 영수증 구조 — 본문=총액 3줄, 별첨=전체 품목 명세서",
    beforeLabel: "결론을 묻어두는 방식",
    afterLabel: "나쁜 소식 즉시 선공개",
    before: "지난 3개월간 팀원들이\n열심히 노력하였으나...\n\n...(2페이지 열심히 내역)...\n\n결론적으로 이번 분기\n목표를 달성하지 못했습니다.\n\n(→ 불쾌한 서프라이즈)",
    after: "⚠️ 3분기 목표 미달성\n   달성률: 72%  (목표 100억, 실적 72억)\n\n원인: 주요 고객 3곳 계약 해지\n\n즉시 대책:\n  ① 이탈 고객 긴급 면담 (이번 주)\n  ② 대체 파이프라인 3건 가시화",
  },

  {
    id: 31,
    category: "독자 중심",
    title: "예상 질문 선제 답변",
    subtitle: "\"이거 혹시~\"를 본문에서 먼저 해소",
    description: "보고를 받는 사람이 \"이거 혹시 비용은 얼마야?\", \"리스크는 없어?\"라고 태클 걸 만한 질문 3가지를 미리 상상하고 본문 안에서 선제로 답변하세요.",
    detail: "태클을 진압하면서 통과하는 보고서가 진짜 잘 쓴 보고서입니다.",
    icon: "Key",
    color: "emerald",
    memo: "🩺 솔직한 의사 — 빙빙 돌리는 의사보다 바로 말하는 의사가 신뢰받는다",
    beforeLabel: "질문 유발 보고서",
    afterLabel: "질문 차단 선제 답변",
    before: "신규 시스템 도입을 건의합니다.\n기대 효과는 업무 효율 향상.\n\n[회의에서]\n\"비용이 얼마야?\"\n\"도입 기간은?\"\n\"실패하면 어떡해?\"\n\n(→ 현장에서 멈추는 보고)",
    after: "신규 시스템 도입 건의\n\nQ: 비용은? → 도입비 5천만, 월 유지 50만\nQ: 기간은? → 3개월 (테스트 포함)\nQ: 실패 시? → 기존 시스템 병행 유지\n\n(→ 태클이 없어 바로 승인)",
  },

  {
    id: 32,
    category: "독자 중심",
    title: "보고 대상별 버전 관리",
    subtitle: "결재자용·전달자용·참조자용은 다르다",
    description: "한 가지 보고서를 임원부터 실무자까지 모두에게 그대로 전달하는 것은 실수입니다. 목적과 역할에 따라 판을 달리 만드세요.",
    detail: "임원 = 결정 요청 / 중간관리자 = 실행 지시 / 실무자 = 작업 가이드. 독자마다 필요한 정보 깊이가 다릅니다.",
    icon: "Users",
    color: "emerald",
    memo: "♟️ 체스 3수 앞 예측 — '이쪽 치면 저쪽 물어보겠지'를 미리 본문에",
    beforeLabel: "모두에게 같은 버전",
    afterLabel: "대상별 맞춤 버전",
    before: "[임원에게 15장 전달]\n\"세부 일정표 페이지 12 참고하세요\"\n\"KPI 산출 근거는 별첨 3번입니다\"\n\n(→ 임원이 15장을 뒤져야 함)",
    after: "📄 임원용 (1장): 결정 + 기대효과\n📄 팀장용 (3장): 실행 계획 + 일정\n📄 실무용 (10장): 세부 작업 가이드\n\n(→ 각자 필요한 것만 읽음)",
  },

  {
    id: 46,
    category: "독자 중심",
    title: "구두 보고와 서면 보고 구분법",
    subtitle: "사안 크기에 맞는 포맷을 골라라",
    description: "모든 것을 서면으로 만드는 것은 과잉 노력입니다. 반대로 중요한 결재를 구두만으로 처리하면 책임이 흐릿해집니다. 사안의 중요도에 따라 포맷을 선택하세요.",
    detail: "포맷이 맞지 않으면 처리 속도도 떨어집니다. 슬랙 한 줄이면 될 것을 A4 3장으로 만들면 둘 다 손해입니다.",
    icon: "Mic",
    color: "emerald",
    memo: "🚒 소방차 원칙 — 불부터 끄고 보고서는 나중에 쓴다",
    beforeLabel: "모든 것을 서면으로 (과잉)",
    afterLabel: "사안 크기별 포맷 선택",
    before: "단순 일정 변경 → A4 보고서 1장\n긴급 현황 공유 → 보고서 3장\n중요 결재 → 메일 3줄 메모\n\n(→ 중요한 것이 소홀히 처리됨\n    사소한 것에 에너지 낭비)",
    after: "단순 변경·공유 → 슬랙/문자 1줄\n현황 파악 필요 → 구두 3분 보고\n실무 협의 → 메모지 1장\n공식 결재 사안 → 서면 보고서\n\n(→ 포맷이 맞으면\n    처리 속도 3배 향상)",
  },

  {
    id: 55,
    category: "독자 중심",
    title: "수요자(결재자) 맞춤 커스터마이징",
    subtitle: "보고서는 내가 쓰고 싶은 게 아니라 상대가 알고 싶은 것",
    description: "보고자가 힘들게 한 순서나 자신이 잘 아는 과정 중심으로 작성하면 읽히지 않습니다. 의사결정권자가 궁금해하는 결과·판단 기준 중심으로 재편성하세요.",
    detail: "청와대 비서실 & 백승권 원칙. 보고서를 쓰기 전에 \"이 보고를 받는 사람은 무엇을 결정해야 하는가?\"를 먼저 자문하세요.",
    icon: "Users",
    color: "emerald",
    memo: "🔭 망원경 vs 육안 — '멀리'보다 '374km'가 훨씬 실감난다",
    beforeLabel: "작성자 관점 (과정 중심)",
    afterLabel: "결재자 관점 (결과·판단 중심)",
    before: "1. 조사 방법론 설명 (2장)\n2. 수집 데이터 현황 (3장)\n3. 분석 과정 상세 (4장)\n4. 최종 결론 (반 쪽)\n\n(→ 내 노력을 보여주는 구조\n    결재자는 과정을 원하지 않음)",
    after: "▶ 결론: B안 즉시 실행 권고\n   예산 1.2억, 3개월 단축\n\n[배경] 조사 경위 1단락\n[근거] 핵심 데이터 3줄\n[리스크] 주요 리스크 2건\n\n(→ 결재자가 원하는 순서로\n    첫 30초에 판단 가능)",
  },

  {
    id: 56,
    category: "독자 중심",
    title: "행동 요청을 명시하라",
    subtitle: "\"무엇을 해달라는 건지\"를 반드시 써라",
    description: "현황과 데이터를 실컷 나열하고 \"이러한 상황입니다\"로 끝내면 기획서가 아닙니다. 결재자가 정확히 무엇을 승인해야 하는지 명시하세요.",
    detail: "1 Page Proposal 8번째 항목의 핵심. \"~를 검토해 주시기 바랍니다\"가 아니라 \"A안으로 추진을 승인해 주십시오\"처럼 구체적으로 요청하세요.",
    icon: "ArrowRight",
    color: "emerald",
    memo: "🥼 의사 가운 효과 — 같은 말도 가운 입고 하면 사람들이 더 믿는다",
    beforeLabel: "현황 나열 후 흐지부지",
    afterLabel: "구체적 Action 명시",
    before: "\"현재 이러한 상황이며,\n여러 대안을 검토한 결과\n다양한 방향이 존재합니다.\n앞으로 더 살펴볼 필요가\n있을 것으로 생각됩니다.\"\n\n(→ \"그래서 뭘 해달라는 거야?\"\n    결재자의 의사결정 차단)",
    after: "\"따라서 B안(외부업체 위탁)으로\n추진하고자 합니다.\n\n◆ 요청사항:\n  ① 예산 1.2억 원 승인\n  ② 4월 10일 발표 일정 확정\n\n→ 위 2가지를 이번 주 내\n   결재해 주시기 바랍니다.\"",
  },

  // ══════════════════════════════════════════
  // 📌 시각화
  // ══════════════════════════════════════════
  {
    id: 17,
    category: "시각화",
    title: "데이터 시각화 원칙",
    subtitle: "목적별 차트 선택, 핵심 1~2개만",
    description: "시각화는 문서를 꾸미는 것이 아니라 의사결정을 돕는 도구입니다. 핵심 메시지를 위한 1~2개 차트만 선별하세요.",
    detail: "비교→막대, 추이→선, 비중→파이(6개 이하), 관계→산점도",
    icon: "BarChart2",
    color: "rose",
    memo: "🍱 8칸 도시락 — 반찬 8가지를 한 칸씩 빈틈없이 채운다",
    beforeLabel: "차트 12개 (혼란)",
    afterLabel: "차트 2개 (명확)",
    before: "슬라이드 1장에 12개 차트\n\n파이차트 × 4\n막대차트 × 4\n꺾은선 × 2\n레이더차트 × 2\n\n(→ 어디를 봐야 할지 모름)",
    after: "핵심 메시지 1개 = 차트 1개\n\n\"매출 추이\" → 선 차트 1개\n\"지역 비중\" → 파이 차트 1개\n\n나머지는 부록으로 이동\n(→ 메시지가 바로 전달됨)",
  },

  {
    id: 18,
    category: "시각화",
    title: "첫인상 정렬의 법칙",
    subtitle: "들쭉날쭉한 정렬은 신뢰를 깎는다",
    description: "들쭉날쭉한 폰트, 삐뚤어진 줄 맞춤은 내용의 허술함을 암시합니다. 텍스트와 박스의 여백을 통일하세요.",
    detail: "슬라이드 간 제목 위치가 1픽셀도 움직이지 않는 \"그리드 시스템\" 마인드가 신뢰감을 형성합니다.",
    icon: "AlignLeft",
    color: "rose",
    memo: "🎻 독주회 원칙 — 한 무대에 바이올린+드럼 동시면 소음이다",
    beforeLabel: "정렬 불일치 (산만)",
    afterLabel: "그리드 통일 (안정감)",
    before: "슬라이드마다:\n제목 위치 제각각\n글씨 크기: 14pt / 16pt / 13pt 혼재\n들여쓰기: 없음 / 1cm / 0.5cm\n\n(→ \"대충 만들었다\"는 인상)",
    after: "전 슬라이드 공통:\n제목: 상단 1.5cm, 18pt Bold\n본문: 들여쓰기 0.7cm, 12pt\n여백: 좌우 대칭 2cm\n\n(→ \"꼼꼼하다\"는 신뢰감)",
  },

  {
    id: 33,
    category: "시각화",
    title: "여백을 30% 비워라",
    subtitle: "가득 채운 슬라이드는 아무것도 말하지 않는다",
    description: "슬라이드 면적의 30%는 반드시 여백으로 남겨야 시선이 핵심으로 유도됩니다. 빽빽하게 채운 것이 성의가 아니라 혼란입니다.",
    detail: "여백은 \"이거 봐\"라고 독자의 시선을 끄는 조용한 화살표입니다.",
    icon: "BarChart2",
    color: "rose",
    memo: "👔 TPO 옷차림 — 결재자=정장, 전달자=캐주얼, 참조자=편한 복장",
    beforeLabel: "꽉 채운 슬라이드",
    afterLabel: "여백 30% 확보",
    before: "글자 수: 350자\n이미지: 3개\n표: 2개\n차트: 2개\n\n→ 슬라이드 한 장에 모두 배치\n\n(→ 어디를 봐야 할지 모름\n    에너지가 분산됨)",
    after: "글자 수: 80자 (핵심만)\n이미지: 없음\n차트: 1개\n여백: 30% 이상\n\n(→ 차트로 시선이 자동 이동\n    메시지가 즉각 전달됨)",
  },

  {
    id: 34,
    category: "시각화",
    title: "색상 3색 룰",
    subtitle: "3가지 초과 = 디자인이 아닌 혼돈",
    description: "보고서 한 장에 사용하는 색상은 3가지 이내로 제한합니다. 주색 1개 + 강조색 1개 + 중립색 1개면 충분합니다.",
    detail: "색을 많이 쓸수록 어디가 중요한지 모르게 됩니다. 강조가 없는 것과 같습니다.",
    icon: "Lightbulb",
    color: "rose",
    memo: "📱 문자 vs 통화 — 사안 크기에 맞는 채널을 골라야 한다",
    beforeLabel: "7색 사용 (모두 강조)",
    afterLabel: "3색 원칙 (핵심만 강조)",
    before: "제목: 파랑\n소제목: 초록\n강조: 빨강\n본문: 검정\n배경: 회색\n보조: 노랑\n기타: 주황\n\n(→ 모든 것이 강조 =\n    아무것도 강조 안 됨)",
    after: "주색:  네이비 (제목, 구조)\n강조색: 인디고 (핵심 수치만)\n중립색: 슬레이트 (본문)\n\n(→ 인디고를 보면 \"여기가 핵심\"\n    시선이 정확히 이동)",
  },

  {
    id: 35,
    category: "시각화",
    title: "표와 그래프, 언제 쓸까",
    subtitle: "정확한 수치 → 표 / 패턴·흐름 → 그래프",
    description: "표는 개별 수치를 정확히 전달할 때, 그래프는 변화 추이나 비교 패턴을 직관적으로 보여줄 때 사용합니다.",
    detail: "둘을 동시에 넣으면 독자는 어디에 집중해야 할지 혼란스러워합니다. 하나만 선택하세요.",
    icon: "BarChart3",
    color: "rose",
    memo: "🎁 선물 포장술 — 받는 사람 취향대로 골라야 진심이 닿는다",
    beforeLabel: "표 + 그래프 동시 (중복)",
    afterLabel: "목적에 맞게 1가지",
    before: "같은 매출 데이터를\n표로도 보여주고\n→ 막대 그래프로도 보여줌\n\n슬라이드 1장에 두 가지 모두\n\n(→ 중복 정보, 슬라이드 낭비\n    어디에 집중해야 할지 모름)",
    after: "정확한 숫자가 필요한가?\n  → 표 선택\n  예: 분기별 지역별 매출 비교\n\n추이·비율이 핵심인가?\n  → 그래프 선택\n  예: 매출 12개월 트렌드\n\n(→ 하나만, 명확하게)",
  },

  {
    id: 57,
    category: "시각화",
    title: "상황별 차트 선택 원칙",
    subtitle: "비교엔 막대, 추이엔 선, 비중엔 파이",
    description: "차트는 종류에 따라 전달하는 메시지가 다릅니다. 잘못된 차트를 쓰면 데이터가 왜곡되거나 의도적 오해를 줄 수 있습니다.",
    detail: "파이 차트는 항목이 5개를 초과하거나 값 차이가 미세할 때 사용을 지양하세요. 3D 효과는 비율을 왜곡하므로 절대 사용 금지입니다.",
    icon: "PieChart",
    color: "rose",
    memo: "🗳️ 선거 유세의 진실 — 당일 연설보다 3일 전 집집마다 악수가 강하다",
    beforeLabel: "엉뚱한 차트 선택 (왜곡)",
    afterLabel: "메시지에 맞는 차트 선택",
    before: "추이 데이터에 파이 차트 사용\n→ 시간 흐름을 보여줄 수 없음\n\n비교 데이터에 3D 원형 차트\n→ 원근법으로 비율 왜곡\n\n항목 15개짜리 파이 차트\n→ 색상 범례만으로 판독 불가\n\n(→ 차트가 오히려 혼란 가중)",
    after: "📊 비교 → 세로/가로 막대 차트\n   (축은 반드시 0에서 시작)\n\n📈 추이 → 선 차트\n   (시간은 왼→오른쪽)\n\n🥧 비중 → 파이 차트\n   (5개 이하, 2D만 사용)\n\n🔵 관계 → 산점도/버블 차트\n\n(→ 차트 자체가 결론을 말함)",
  },

  {
    id: 58,
    category: "시각화",
    title: "색상 3색 원칙 + 여백 확보",
    subtitle: "무지개색 차트와 빽빽한 텍스트는 읽히지 않는다",
    description: "색상은 강조할 핵심 데이터에만 한 가지 강한 색을 쓰고, 나머지는 회색 계열로 처리하세요. 시선이 자동으로 중요한 데이터로 향합니다.",
    detail: "한 슬라이드에 사용할 색상은 최대 3가지를 초과하지 마세요. 여백은 낭비가 아니라 독자에게 숨 쉴 공간을 주는 디자인 원칙입니다.",
    icon: "Palette",
    color: "rose",
    memo: "🔱 삼지창 법칙 — 2개는 부족, 4개는 과하다, 3이 뇌의 최적값",
    beforeLabel: "무지개색 + 빽빽한 텍스트",
    afterLabel: "3색 원칙 + 충분한 여백",
    before: "10가지 색상의 3D 파이 차트\n한 페이지에 글자 800자\n줄간격 100% (숨막힘)\n형광 하이라이트 7곳\n빨간색 강조 12군데\n\n(→ 눈이 어디를 봐야 할지 모름\n    중요한 것이 묻혀버림)",
    after: "주요 항목: 진한 파란색 1가지\n나머지: 회색 계열\n배경: 흰색 + 충분한 여백\n줄간격: 140~160%\n강조: 최대 2~3곳만\n\n(→ 시선이 자동으로 핵심에 집중\n    30초 만에 메시지 전달 완료)",
  },

  // ══════════════════════════════════════════
  // 📌 실전 전략
  // ══════════════════════════════════════════
  {
    id: 19,
    category: "실전 전략",
    title: "최악의 보고서 4대 패턴",
    subtitle: "절대 하지 말아야 할 4가지",
    description: "①작성자 중심 서술 ②불필요한 정보 과다 나열 ③사실과 의견 혼동 ④막연한 결론, 이 4가지만 피해도 품질이 70% 오릅니다.",
    detail: "가장 흔한 패턴: 노력을 과시하려 목적과 무관한 배경지식을 몽땅 포함하는 것.",
    icon: "XCircle",
    color: "amber",
    memo: "🔬 현미경 글쓰기 — '많이'는 안 보이고, '37명'은 또렷하게 보인다",
    beforeLabel: "4대 패턴 모두 해당",
    afterLabel: "4대 패턴 회피",
    before: "\"당사의 매출 부진은\n외부 환경에 기인하며,\n향후 지속적인 노력을 통해\n개선될 것으로 기대됩니다.\"\n\n① 변명  ② 모호  ③ 주관\n④ 실행 계획 없음",
    after: "3분기 매출 –12%\n\n원인: 원자재비 +35%\n      경쟁사 신제품 출시 2건\n\n대책:\n  ① 가격 재협상 (5/15까지)\n  ② 신규 채널 발굴 (2개사)",
  },

  {
    id: 20,
    category: "실전 전략",
    title: "보고 타이밍의 법칙",
    subtitle: "골든 타임을 공략하라",
    description: "아무리 훌륭한 기획서도 의사결정자가 스트레스에 시달리는 타이밍엔 버려집니다. 물리적·심리적 여유가 있는 시간대를 노려야 합니다.",
    detail: "결재자의 심리적, 물리적 여유 상태도 보고서의 성공 인자입니다.",
    icon: "Clock",
    color: "amber",
    memo: "🔫 기관총 문체 — 짧고 끊어서 연속으로, 총알이 하나씩 박힌다",
    beforeLabel: "최악의 타이밍",
    afterLabel: "황금 타이밍",
    before: "× 월요일 오전 9시\n  (주간 회의 준비 중)\n\n× 중요 회의 10분 전\n  (생각 정리 중)\n\n× 퇴근 5분 전\n  (머릿속이 이미 귀가 중)",
    after: "✓ 화·수요일 오후 2~3시\n  (식후 + 주요 회의 없는 시간)\n\n✓ 월요일 오전 일과 마무리 후\n  (긴급 아젠다 정리된 이후)\n\n✓ 보고 전날 \"내일 보고드릴게요\" 예고",
  },

  {
    id: 21,
    category: "실전 전략",
    title: "급할 땐 보고서 쓰지 마라",
    subtitle: "위기 상황 = 구두 보고가 1순위",
    description: "크리티컬한 재난 현장에서 워드로 표를 그리고 앉아 있는 것은 죄악입니다. 백지 메모 하나 들고 30초 대면 보고를 먼저 하세요.",
    detail: "서류 작업은 소통의 수단일 뿐 목적이 아닙니다.",
    icon: "Siren",
    color: "amber",
    memo: "�� 동일인 다른 이름 금지 — '홍길동/길동씨/그' 는 독자를 헷갈리게 한다",
    beforeLabel: "보고서부터 (느림)",
    afterLabel: "구두 먼저 (빠름)",
    before: "공장 라인 멈춤\n↓\nPC 앞에 앉아\n보고서 작성 중...\n↓\n1시간 후 보고\n\n(→ 골든타임 1시간 낭비)",
    after: "공장 라인 멈춤\n↓\n30초 구두 보고\n\"라인 3번 중단, 원인 조사 중\"\n↓\n수습 지시 받음\n↓\n안정화 후 보고서 작성",
  },

  {
    id: 22,
    category: "실전 전략",
    title: "마지막 퇴고 룰",
    subtitle: "프린트 후 소리 내어 읽기",
    description: "종이로 출력해서 입 밖으로 소리 내어 읽어보는 5분이 문서 퀄리티를 바꿉니다. 호흡이 꼬이는 지점을 귀신같이 찾아냅니다.",
    detail: "리듬감이 깨지거나 주술 호응이 안 맞는 문장들을 육성으로 디버깅할 수 있습니다.",
    icon: "Mic",
    color: "amber",
    memo: "🏗️ 건물 짓기 순서 — 설계도(목차) 먼저, 벽돌(내용) 나중",
    beforeLabel: "화면으로만 검토",
    afterLabel: "출력 + 소리 내어 읽기",
    before: "화면에서만 읽고\n\"이상 없어 보임\"\n\n제출 후 발견:\n• 주어-동사 불일치\n• 같은 단어 3번 반복\n• 숫자 오탈자\n\n(→ 이미 늦음)",
    after: "출력 → 소리 내어 읽기\n\n어색한 지점에서\n자동으로 말이 막힘\n↓\n그 문장을 바로 고침\n\n(→ 5분 투자, 오류 90% 제거)",
  },

  {
    id: 36,
    category: "실전 전략",
    title: "15초 요약 테스트",
    subtitle: "엘리베이터 함께 타면 핵심을 말할 수 있나?",
    description: "\"임원과 엘리베이터를 함께 탔을 때, 15초 안에 이 보고서의 핵심을 말할 수 있는가?\" 를 기준으로 보고서를 점검하세요.",
    detail: "15초 안에 말 못 하면 아직 자신도 핵심을 모르는 겁니다. 그 상태로 쓰면 보고서도 흐릿해집니다.",
    icon: "Zap",
    color: "amber",
    memo: "🛎️ 호텔 프런트 벨 — 눌러야 뭔가 온다, 요청 없으면 움직임도 없다",
    beforeLabel: "핵심 정리 안 됨",
    afterLabel: "15초 핵심 문장 준비",
    before: "[임원과 엘리베이터]\n\"저기... 이번에 신규 채널\n관련해서 외부 환경도 보고\n내부 역량도 분석해서\n뭐 여러 가지를 검토했는데...\"\n\n→ 3층 도착, 아무것도 전달 못 함",
    after: "[임원과 엘리베이터]\n\"경쟁사 대비 디지털 채널 부재로\n신규 고객 유입이 30% 부족합니다.\n3개월 내 2개 채널 추가를\n승인 부탁드립니다.\"\n\n→ 1층에서 3층 도착 전에 완료",
  },

  {
    id: 37,
    category: "실전 전략",
    title: "동료에게 먼저 검토 받아라",
    subtitle: "작성자 본인은 절대 오류를 못 찾는다",
    description: "자신이 쓴 보고서의 오류는 작성자 본인이 가장 못 찾습니다. 제출 전 반드시 다른 팀원에게 먼저 읽히고 \"핵심이 뭔지 말해봐\"를 테스트하세요.",
    detail: "\"핵심이 무엇인지 말해봐\" → 동료가 막히면 독자도 막힙니다.",
    icon: "Users",
    color: "amber",
    memo: "🔧 공구함 법칙 — 못엔 망치, 나사엔 드라이버, 데이터도 맞는 도구",
    beforeLabel: "혼자 완성 → 제출",
    afterLabel: "동료 테스트 → 수정 → 제출",
    before: "혼자 3일간 작성\n→ \"완벽해 보인다\"\n→ 제출\n\n[피드백]\n결재자: \"근거 데이터가 없네\"\n동료:   \"결론이 뭔지 모르겠어\"\n\n(→ 이미 제출된 뒤)",
    after: "초안 완성\n→ 팀원에게: \"핵심이 뭔지 말해봐\"\n→ 팀원: \"음... 두 번째 장인가?\"\n→ BLUF 구조 재배치\n→ 재확인 후 제출\n\n(→ 제출 전에 문제 발견)",
  },

  {
    id: 38,
    category: "실전 전략",
    title: "\"왜 지금?\" 긴박성 명시",
    subtitle: "지금 결정해야 하는 이유를 명시하라",
    description: "아무리 훌륭한 기획이라도 \"왜 지금 결정해야 하는지\"가 없으면 미루어집니다. 의사결정 데드라인과 지연 시 불이익을 명확히 기재하세요.",
    detail: "결재자는 항상 바쁩니다. 지금 결정해야 하는 이유가 없으면 \"나중에\"가 됩니다.",
    icon: "Clock",
    color: "amber",
    memo: "🖼️ 삐딱한 액자 — 내용이 좋아도 정렬이 흐트러지면 집중을 잃는다",
    beforeLabel: "긴박성 없음 (미룸 유발)",
    afterLabel: "데드라인 + 불이익 명시",
    before: "\"신규 시스템 도입 건의\"\n\n좋은 제안이니 검토 부탁드립니다.\n의사결정은 편하신 때에 해주세요.\n\n(→ 결재자: \"나중에 보지 뭐\"\n    → 3달 뒤에도 결재 안 됨)",
    after: "\"신규 시스템 도입 건의\"\n\n⏰ 결정 데드라인: 3/15\n이유: 3/16 이후 도입 시\n      1분기 연동 불가 (6개월 지연)\n      추가 비용 2천만 원 발생\n\n(→ \"왜 지금?\"이 명확 → 즉시 결재)",
  },

  {
    id: 47,
    category: "실전 전략",
    title: "상황·문제·해결 구조",
    subtitle: "맥킨지식 스토리텔링 압축법",
    description: "Situation(상황) → Complication(갈등·문제) → Resolution(해결책) 3단계로 모든 스토리를 압축합니다. 복잡한 보고서도 이 구조에 끼워 맞추면 논리가 명쾌해집니다.",
    detail: "SCR의 관건은 S(배경 설명)를 짧게 끊는 것입니다. C(갈등)으로 빨리 진입해야 독자의 주의가 집중됩니다.",
    icon: "GitMerge",
    color: "amber",
    memo: "🎤 리허설이 공연을 살린다 — 소리 내어 읽어야 이상한 부분이 들린다",
    beforeLabel: "기·승·전·결 (긴 서사)",
    afterLabel: "S→C→R (압축 스토리)",
    before: "배경 설명 3장\n문제 상황 설명 2장\n원인 분석 3장\n드디어 해결책 2장\n\n(→ 기승전결 소설처럼 긴 전개\n    임원이 끝까지 읽는 경우 드묾)",
    after: "S (상황): 2년간 안정적 성장 유지\nC (갈등): 3분기 급반전 매출 -12%\nR (해결): 가격 재협상 + 신채널 2개\n\n→ 맥킨지식 압축 스토리\n  \"상황→갈등→해결\" 3문장 완성",
  },

  {
    id: 48,
    category: "실전 전략",
    title: "보고 후 24시간 후속 점검",
    subtitle: "결재 받고 끝내면 신뢰를 잃는다",
    description: "결재나 보고를 마친 후 24시간 이내에 \"착수 보고\"를 간단히 전달하세요. \"실행에 들어갔다\"는 시그널이 결재자의 신뢰를 쌓습니다.",
    detail: "\"보고하고 사라지는 사람\" vs \"24시간 내 착수 알림을 보내는 사람\" — 장기적 신뢰 자산의 차이가 됩니다.",
    icon: "Clock",
    color: "amber",
    memo: "🛗 엘리베이터 3층 테스트 — 3층 올라가기 전에 설명이 끝나야 한다",
    beforeLabel: "결재 후 침묵 (신뢰 낭비)",
    afterLabel: "24시간 내 착수 보고 (신뢰 적립)",
    before: "결재 완료\n\n1주일 후...\n결재자: \"그거 시작했어?\"\n나: \"네... 준비 중입니다...\"\n\n(→ \"왜 아직도?\" 불신 시작\n    실행력 의심받음)",
    after: "결재 완료 → 24시간 내\n\n\"○○ 건 착수 보고드립니다.\n오늘 킥오프 완료,\n3/15 1차 결과 공유 예정입니다.\"\n\n→ \"이 사람 믿을 수 있군\"\n(→ 신뢰 자산이 쌓임)",
  },

  // ══════════════════════════════════════════
  // 📌 심리·설득 전략
  // ══════════════════════════════════════════
  {
    id: 39,
    category: "심리·설득 전략",
    title: "앵커링 효과",
    subtitle: "첫 숫자가 기준점이 된다",
    description: "사람의 뇌는 처음 접한 숫자를 기준점(앵커)으로 삼아 이후 판단을 내립니다. 예산·수량·기간을 제시할 때 먼저 높은 숫자를 앵커로 심어두면, 실제 요청이 합리적으로 느껴집니다.",
    detail: "협상의 주도권은 첫 숫자를 제시하는 쪽이 쥡니다. 낮게 시작하면 낮은 결과로 귀결됩니다.",
    icon: "Target",
    color: "violet",
    memo: "🛁 욕조 법칙 — 물을 끝까지 채우면 넘친다, 슬라이드도 마찬가지",
    beforeLabel: "낮은 앵커 → 낮은 결과",
    afterLabel: "높은 앵커 → 목표 확보",
    before: "예산 2억 원을 요청했다\n→ \"비싸다\" 즉시 거절\n\n처음부터 낮은 숫자를 제시해\n협상 여지가 없어짐\n\n(→ 앵커가 낮으면 결과도 낮음)",
    after: "먼저 언급: \"업계 표준은 5~7억 규모\"\n→ \"저희 최소 필요 비용은 2억\"\n\n5억 기준에서 보면 2억이 저렴해 보임\n\n(→ 첫 숫자 = 협상의 기준점)",
  },

  {
    id: 40,
    category: "심리·설득 전략",
    title: "잃는 게 있다고 말해라",
    subtitle: "\"이익 1억\"보다 \"손실 1억 방지\"가 2배 강하다",
    description: "인간의 뇌는 동일한 금액이라도 \"얻는 것\"보다 \"잃는 것\"에 약 2배 민감하게 반응합니다. 제안의 결과를 이익이 아닌 손실 회피로 프레이밍하세요.",
    detail: "다니엘 카너먼의 행동경제학 연구. 이득 1만원 vs 손실 1만원 — 손실이 훨씬 크게 느껴집니다.",
    icon: "AlertTriangle",
    color: "violet",
    memo: "🚦 신호등 3색 — 전 세계가 3색으로 소통한다, 차트도 충분하다",
    beforeLabel: "이익 강조 (약한 설득)",
    afterLabel: "손실 회피 강조 (강한 자극)",
    before: "\"이 시스템을 도입하면\n 연간 1억의 이익이 납니다.\"\n\n(→ \"그래서?\" 반응\n    미래 이익은 와닿지 않음)",
    after: "\"지금 도입 안 하면\n 연간 1억의 손실이 확정됩니다.\"\n\n(→ \"그게 진짜야?\" 즉각 집중\n    손실이 이익보다 2배 자극)",
  },

  {
    id: 41,
    category: "심리·설득 전략",
    title: "구체성의 설득력",
    subtitle: "\"17.3%\"가 \"약 20%\"보다 신뢰를 준다",
    description: "소수점이 붙은 구체적인 숫자는 \"직접 측정했다\"는 신뢰 신호를 보냅니다. \"약 20%\"는 어림잡은 것처럼 보이지만, \"17.3%\"는 정밀하게 검증한 것처럼 보입니다.",
    detail: "단, 실제로 측정하지 않은 수치에 소수점을 만들어 붙이는 것은 신뢰를 망가뜨립니다. 진짜 데이터에서만 활용하세요.",
    icon: "BarChart3",
    color: "violet",
    memo: "📷 사진 vs 영상 — 순간 정밀=표, 흐름·패턴=그래프",
    beforeLabel: "어림수 (모호·불신)",
    afterLabel: "정밀수 (신뢰·검증)",
    before: "\"약 20% 개선이 기대됩니다.\"\n\"상당한 성과 예상.\"\n\"빠른 시일 내 완료 예정.\"\n\n(→ 근거 없이 부풀린 느낌\n    왜 믿어야 하는지 모름)",
    after: "\"17.3% 개선 (전년 동기 대비)\"\n\"NPS 62→78점 (+26%)\"\n\"2025년 3월 15일 완료 예정\"\n\n(→ 소수점 하나가\n    신뢰도를 2배 올림)",
  },

  {
    id: 42,
    category: "심리·설득 전략",
    title: "권위 인용 효과",
    subtitle: "외부 출처가 내 주장을 면책시킨다",
    description: "같은 주장이라도 객관적 외부 기관(맥킨지, 가트너, 통계청 등)의 데이터를 인용하면 설득력이 수직 상승합니다. \"내 말\"이 아닌 \"전문가의 말\"이 되기 때문입니다.",
    detail: "인용 시 출처·연도·대상을 반드시 명시하세요. \"어딘가에서 봤다\" 수준의 인용은 역효과가 날 수 있습니다.",
    icon: "BookOpen",
    color: "violet",
    memo: "🍽️ 음식별 도구 — 비교=막대(젓가락), 추이=선(수저), 비중=파이(포크)",
    beforeLabel: "내 주장만 (신뢰 낮음)",
    afterLabel: "외부 권위 인용 (신뢰 상승)",
    before: "\"저희 분석에 따르면\n이 시장은 성장 가능성이 높습니다.\"\n\n(→ 내 말 vs 내 말\n    왜 믿어야 하는지 근거 없음)",
    after: "\"McKinsey 2024: 연 18% 성장 예측\"\n\"가트너: 3년 내 도입률 64% 전망\"\n\"경쟁사 A는 이미 2년 전 도입\"\n\n(→ 외부 권위 = 내 주장의\n    검증된 근거)",
  },

  {
    id: 43,
    category: "심리·설득 전략",
    title: "미리 지지자를 만들어라",
    subtitle: "보고 당일이 아니라 3일 전에 이미 설득",
    description: "중요한 보고 전에 핵심 반대자 또는 이해관계자를 1:1로 미리 만나 우려 사항을 청취하고 선제로 해소해 두세요. 공식 보고 당일은 \"합의 확인\"의 의식에 가깝게 만드는 것이 목표입니다.",
    detail: "공개 회의에서 반대 의견이 나오면 체면이 걸려 철회하기 어렵습니다. 비공식 대화에서 미리 해소하는 것이 훨씬 쉽습니다.",
    icon: "Users",
    color: "violet",
    memo: "🎨 명품 로고 원칙 — 명품은 항상 여백이 많고 색은 적다",
    beforeLabel: "보고 당일 첫 공개 (위험)",
    afterLabel: "3일 전 1:1 선제 해소 (안전)",
    before: "보고 당일 처음 공개\n\n\"리스크가 너무 큰데요\"\n\"예산을 어떻게 쓸 거예요?\"\n\"왜 지금이에요?\"\n\n→ 회의가 격전지로 변함\n(→ 보고 기각)",
    after: "보고 3일 전:\n  핵심 반대자 1:1 면담\n  → 우려 사항 수렴 + 보고서 반영\n\n보고 당일:\n  \"지난번 말씀하신 우려는\n   FAQ에 답변드렸습니다.\"\n  → 30분 만에 승인",
  },

  {
    id: 44,
    category: "심리·설득 전략",
    title: "세 가지로 묶어라",
    subtitle: "인간의 뇌는 3개를 가장 잘 기억한다",
    description: "근거, 요점, 선택지 등을 나열할 때는 항상 3개로 정리하세요. 2개는 너무 적고, 4개 이상은 기억이 흐려집니다. \"3\"은 압도적으로 기억에 잘 남는 묶음입니다.",
    detail: "\"1등 금메달, 2등 은메달, 3등은?\" — 누구나 답합니다. 하지만 4등이 뭔지는 아는 사람이 드뭅니다.",
    icon: "Key",
    color: "violet",
    memo: "🚫 교통 위반 4종 — 신호무시·역주행·과속·음주, 하나만 걸려도 끝",
    beforeLabel: "근거 7가지 나열 (기억 안 남)",
    afterLabel: "핵심 3가지 (모두 기억)",
    before: "근거 7가지 나열:\n① ② ③ ④ ⑤ ⑥ ⑦\n\n\"어느 게 핵심이에요?\"\n\"이게 다 중요해요?\"\n\n(→ 많을수록 기억에 남는 건 0개)",
    after: "핵심 근거 딱 3가지:\n① 비용 절감 2억\n② 일정 단축 3개월\n③ 리스크 최소화\n\n\"3개\"는 뇌가 자연스럽게\n기억하는 최적 묶음\n\n(→ 3개 → 전부 기억됨)",
  },

  {
    id: 59,
    category: "심리·설득 전략",
    title: "비교해서 보여줘라",
    subtitle: "뇌는 단독 정보보다 비교 정보에 반응한다",
    description: "타사·과거·대안과의 명확한 비교표 하나가 주장 10줄보다 강력합니다. 독자의 뇌는 이질적인 차이를 인식할 때 가장 빠르게 판단을 내립니다.",
    detail: "기획의 정석 핵심 전술. 비교표는 항목을 3개 이하로 절제하고, 내 안의 우위 수치를 첫 번째 열에 배치하세요.",
    icon: "BarChart",
    color: "violet",
    memo: "🪄 마술사 카드 2장 — 1장만 보면 모르고, 2장 비교하면 속임수 보인다",
    beforeLabel: "단독 주장 (비교 없음)",
    afterLabel: "비교표로 우위 즉시 전달",
    before: "\"A 시스템은 처리 속도가\n빠르고 안정성이 높습니다.\"\n\n(→ \"빠른 게 얼마나 빠른데?\"\n    \"안정성이 높다는 기준이 뭐지?\"\n    → 판단 기준 없어 설득 실패)",
    after: "         현재 시스템  A 시스템\n처리속도  100ms      30ms ✓ 3배\n안정성    99.1%      99.9% ✓\n월비용    150만원     90만원 ✓ -40%\n\n(→ 30초 안에 \"A가 낫군\" 결론\n    별도 설명 불필요)",
  },

  {
    id: 60,
    category: "심리·설득 전략",
    title: "세 가지 근거 법칙",
    subtitle: "근거는 2개도 4개도 아닌 정확히 3개",
    description: "근거가 2개이면 빈약해 보이고, 4개 이상이면 산만해집니다. 3개가 기억에 가장 잘 남고 설득력이 가장 강합니다. \"첫째, 둘째, 셋째\"가 최강의 구조입니다.",
    detail: "[\"자유, 평등, 박애\"] [\"빠르고, 안전하고, 저렴하게\"] 등 역사적으로 검증된 3의 법칙. 보고서 논거도 반드시 3개로 압축하세요.",
    icon: "List",
    color: "violet",
    memo: "🥇 시상대 원칙 — 3등까지만 올라간다, 근거도 3개면 충분하다",
    beforeLabel: "근거가 너무 많거나 적음",
    afterLabel: "정확히 3개 근거 (최강 설득)",
    before: "[근거 2개] \"비용이 절감되고\n빠릅니다.\" → 빈약\n\n[근거 6개] \"빠르고, 저렴하고,\n안전하고, 확장성 있고, 지원 좋고,\n레퍼런스가 많습니다.\" → 산만\n\n(→ 2개는 부족, 6개는 기억 불가)",
    after: "\"이 방안을 추천하는\n3가지 이유가 있습니다:\n\n첫째, 비용 40% 절감\n둘째, 처리 속도 3배 향상\n셋째, 업계 레퍼런스 50건 확보\n\n(→ \"첫째·둘째·셋째\"가\n    뇌에 선명하게 각인됨)",
  },

  {
    id: 61,
    category: "심리·설득 전략",
    title: "대형마트 카테고리화 원칙",
    subtitle: "표지판이 없는 마트에서는 아무것도 못 산다",
    description: "10~20개 세부 계획을 구분 없이 일렬 번호로 나열하면 독자가 길을 잃습니다. 3~4개 명확한 카테고리로 묶고 소제목을 달아 구조를 만드세요.",
    detail: "백승권 보고서의 법칙 핵심. 대형마트의 \"과일/채소/음료/냉동식품\" 표지판처럼, 보고서의 소제목이 독자의 내비게이션이 됩니다.",
    icon: "Grid",
    color: "violet",
    memo: "🏪 마트 표지판 — 표지판 없는 마트에선 계란도 못 찾는다",
    beforeLabel: "구분 없는 나열 (길을 잃음)",
    afterLabel: "카테고리 + 소제목 (내비게이션)",
    before: "1. 인력 확보 계획\n2. 예산 집행 기준\n3. 일정 조율 방안\n4. 고객 CS 개선\n5. 마케팅 채널 확대\n6. 품질 관리 기준\n7. IT 인프라 준비\n8. 리스크 대응\n\n(→ 읽다가 길을 잃음\n    어디가 중요한지 모름)",
    after: "【인력·조직】\n  · 인력 확보 / 품질 관리\n\n【예산·일정】\n  · 예산 집행 / 일정 조율\n\n【고객·시장】\n  · CS 개선 / 마케팅 확대\n\n【리스크·인프라】\n  · IT 준비 / 리스크 대응\n\n(→ 원하는 정보를 바로 찾음)",
  },

  {
    id: 62,
    category: "심리·설득 전략",
    title: "오탈자 제로 — 신뢰는 디테일에서",
    subtitle: "오탈자 하나가 보고서 전체의 신뢰를 무너뜨린다",
    description: "오탈자와 부정확한 숫자는 작성자의 정성 부족으로 평가되며, 보고서 전체 데이터의 신뢰도를 단숨에 실추시킵니다. 제출 전 3중 검토를 원칙으로 하세요.",
    detail: "삼성형 보고서 6시그마 원칙. ① 맞춤법 검사기 ② 소리 내어 읽기 ③ 하루 뒤 재검토 — 이 3단계를 거치면 오탈자를 99% 잡을 수 있습니다.",
    icon: "CheckCircle",
    color: "violet",
    memo: "🧂 소금의 역설 — 전체의 1%지만 없으면 모든 요리 맛이 망가진다",
    beforeLabel: "오탈자 방치 (신뢰 붕괴)",
    afterLabel: "3중 검토로 신뢰 완성",
    before: "\"2025년 1사분기 매출은\n전년 동기 대비 12%가 증가했으며,\n영업이익율은 8.3%을 기록했습니다.\n특히 북미 사업부가 큰폭의 기여를\n하였슴니다.\"\n\n(→ 이익율(→이익률), 하였슴(→하였음)\n    \"숫자도 맞는 건가?\" 불신 시작)",
    after: "[1차] 맞춤법 검사기 실행\n[2차] 소리 내어 읽으며\n      어색한 문장 수정\n[3차] 하루 뒤 새 눈으로 재검토\n\n\"2025년 1분기 매출은 전년 동기\n대비 12% 증가, 영업이익률 8.3%\n달성. 북미 사업부 기여 최대.\"\n\n(→ 깔끔 = 신뢰)",
  },


  // ══════════════════════════════════════════
  // 🛡️ 신뢰·검증 (3개)
  // ══════════════════════════════════════════
  {
    id: 63,
    category: "신뢰·검증",
    title: "수치엔 출처를 달아라",
    subtitle: "데이터의 신뢰도는 출처가 결정한다",
    description: "모든 수치와 통계에는 출처·기준일·측정 방법을 명시해야 합니다. 출처 없는 숫자는 독자에게 '창작'으로 읽힙니다.",
    detail: "(출처: 기관명, 조사연도, 표본 수) 형식으로 수치 바로 옆 또는 각주에 표기하세요.",
    icon: "ShieldCheck",
    color: "teal",
    memo: "📰 신문 기자 원칙 — 기사 속 모든 숫자 뒤엔 항상 출처 따옴표가 따라온다",
    beforeLabel: "출처 없는 수치 (소설)",
    afterLabel: "출처 명시 (사실)",
    before: "국내 직장인의 73%가\n업무 보고서에 불만족을\n느끼는 것으로 나타났다.\n\n(→ 어디서? 언제? 몇 명 조사?\n    독자는 믿을 근거가 없다)",
    after: "국내 직장인의 73%가\n업무 보고서에 불만족\n(출처: 대한상공회의소,\n2024년 직장인 보고서 인식조사,\n표본 n=1,200)\n\n(→ 수치의 근거가 명확하다)",
  },

  {
    id: 64,
    category: "신뢰·검증",
    title: "반론을 먼저 제시하고 논파하라",
    subtitle: "약점 선제 공개가 신뢰를 만든다",
    description: "예상되는 반론이나 데이터의 한계를 먼저 언급하고, 그럼에도 결론이 유효한 이유를 설명합니다. 약점을 숨기면 독자가 먼저 발견하고 전체를 의심합니다.",
    detail: "'이 분석의 한계는 ~이나, ~이기 때문에 결론은 여전히 유효합니다' 구조를 활용하세요.",
    icon: "Scale",
    color: "teal",
    memo: "⚖️ 변호사의 역전 전략 — 상대 증거를 먼저 인정하고 뒤집어야 배심원이 설득된다",
    beforeLabel: "약점 숨기기 (역효과)",
    afterLabel: "선제 반론 + 논파",
    before: "A 공장 이전이 최적입니다.\n비용 절감 30%, 접근성 향상.\n\n(→ 발표 중 누군가\n'기존 직원 이동 문제는요?'\n→ 준비 안 된 것 노출)",
    after: "A 공장 이전, 직원 이동 이슈\n없진 않습니다. 단, 전직 지원금\n+재택 옵션 병행 시 85% 수용\n의향 확인(사내 설문 n=230).\n비용 절감 효과가 리스크를\n상회합니다.\n\n(→ 반론 선점 → 신뢰 상승)",
  },

  {
    id: 65,
    category: "신뢰·검증",
    title: "현장 검증 없는 분석은 가설이다",
    subtitle: "데이터와 현실 사이의 간극을 확인하라",
    description: "숫자와 인터뷰, 현장 관찰이 불일치할 때 현장이 맞습니다. 보고서 작성 전 반드시 1차 자료(현장)와 2차 자료(통계)를 교차 검증하세요.",
    detail: "맥킨지도 '스모킹 건'이라 부르는 현장 확인을 필수 단계로 둡니다.",
    icon: "Search",
    color: "teal",
    memo: "🕵️ 탐정 원칙 — 셜록 홈즈도 현장에 직접 간다, 서류만 보는 탐정은 없다",
    beforeLabel: "데이터만으로 결론",
    afterLabel: "현장 교차 검증 후 결론",
    before: "시스템 로그 분석 결과\n불량률 2.3%, 정상 범위.\n대응 불필요.\n\n(→ 현장 작업자들은\n '매일 20~30건씩 손수 수정 중'\n→ 로그에 안 잡히는 문제 존재)",
    after: "[데이터] 시스템 불량률 2.3%\n[현장 인터뷰] 작업자 수작업\n수정 일 평균 25건 추가 확인\n[결론] 실제 불량률은 4.1%\n추정, 즉각 점검 필요\n\n(→ 데이터+현장 = 실제 현실)",
  },

  // ══════════════════════════════════════════
  // 📱 디지털 실무 (3개)
  // ══════════════════════════════════════════
  {
    id: 66,
    category: "디지털 실무",
    title: "매체별 최적화",
    subtitle: "같은 내용도 채널이 다르면 포맷이 달라야 한다",
    description: "PDF 보고서, PPT 슬라이드, 이메일 본문, 슬랙 메시지는 각각 다른 포맷이 필요합니다. 하나의 보고서를 모든 채널에 붙여넣기 하면 어디서도 제대로 읽히지 않습니다.",
    detail: "PDF→긴 서술 가능, PPT→슬라이드당 1메시지, 이메일→3문장 요약+첨부, 슬랙→핵심 불릿+링크.",
    icon: "Layers",
    color: "sky",
    memo: "🎭 배우의 연기 변환 — 같은 대사도 영화·TV·무대에서 연기 방식이 다르다",
    beforeLabel: "채널 무관 복붙 (비효율)",
    afterLabel: "채널별 맞춤 포맷",
    before: "이메일로 20페이지 PDF 그대로\n첨부 후 '검토 부탁드립니다'\n\n슬랙에 PPT 전체 캡처 10장\n순서대로 올리기\n\n(→ 읽히지 않음, 응답 없음)",
    after: "[이메일] 핵심 3줄 본문 +\n'상세는 첨부 p.3 참조'\n\n[슬랙] 🔑결론: B안 채택 검토\n• 비용 절감 44%\n• 일정 단축 3개월\n📎 상세 보고서 링크\n\n(→ 채널마다 즉시 소화됨)",
  },

  {
    id: 67,
    category: "디지털 실무",
    title: "AI 초안 활용의 원칙",
    subtitle: "AI가 쓴 초안은 반드시 사실 검증 후 서명하라",
    description: "AI로 초안을 작성하면 속도는 빨라지지만, 사실 오류(환각)와 맥락 이탈이 생깁니다. 최종 서명자가 내용 전체를 책임지므로 AI 결과물을 무검증 제출하는 것은 위험합니다.",
    detail: "AI 활용 시 ①수치 원문 재확인 ②논리 구조 검토 ③조직 맥락 추가 세 단계를 반드시 거치세요.",
    icon: "Bot",
    color: "sky",
    memo: "🤖 AI는 인턴이다 — 빠르고 성실하지만 팩트체크 없이 제출하면 당신이 책임진다",
    beforeLabel: "AI 생성 → 즉시 제출",
    afterLabel: "AI 초안 → 검증 → 서명",
    before: "ChatGPT에 '2024년 반도체\n시장 규모 분석해줘' 요청 후\n결과 그대로 복사·붙여넣기\n\n(→ '출처: 가트너 2023' 인용이\n실제 원문과 수치 다름\n→ 오류 보고서가 결재됨)",
    after: "AI 초안으로 뼈대 작성\n↓\n①수치: 원문 링크 직접 확인\n②논리: So-Because 검증\n③맥락: 우리 회사 상황 추가\n↓\n최종 검토 후 서명\n\n(→ 속도 + 정확도 동시 확보)",
  },

  {
    id: 68,
    category: "디지털 실무",
    title: "보고서 유효기간을 명시하라",
    subtitle: "날짜 없는 보고서는 6개월 후 폭탄이 된다",
    description: "보고서에 '기준일'과 '유효 기간'이 없으면, 1년 후 과거 데이터가 현재 의사결정에 쓰입니다. 특히 시장 환경·법령·금리 등 빠르게 변하는 분야일수록 치명적입니다.",
    detail: "표지 또는 첫 페이지 하단에 '본 보고서는 YYYY.MM 기준이며, 이후 변동사항은 반영되지 않음' 문구를 추가하세요.",
    icon: "CalendarClock",
    color: "sky",
    memo: "🥛 우유 유통기한 — 날짜 없는 우유는 먹어도 되는지 아무도 모른다",
    beforeLabel: "기준일 없는 보고서",
    afterLabel: "기준일·유효기간 명시",
    before: "2023년 작성된 '금리 인상\n영향 분석 보고서'를\n2025년 전략 수립에 그대로 인용\n\n기준금리 3.5% → 현재 1.75%\n시장 상황 완전히 역전\n\n(→ 방향이 반대인 전략 수립)",
    after: "표지 하단:\n'본 보고서는 2023년 6월\n기준 작성이며, 금리·환율\n변동에 따라 재검토 필요.\n유효기간: 작성 후 6개월'\n\n(→ 언제 쓴 분석인지 즉시 파악)",
  },

  // ══════════════════════════════════════════
  // 🔗 협업·프로세스 (3개)
  // ══════════════════════════════════════════
  {
    id: 69,
    category: "협업·프로세스",
    title: "버전 히스토리를 남겨라",
    subtitle: "'최종_진짜최종_진짜진짜최종.pptx' 를 끝내는 법",
    description: "문서 버전 관리 없이 협업하면 어떤 파일이 최신인지 아무도 모릅니다. 파일명에 v1.0, 날짜, 수정자 이니셜을 기록하고 변경 이력을 남기면 혼란이 90% 줄어듭니다.",
    detail: "파일명: 보고서명_v2.1_240419_KH.pptx / 첫 페이지 변경이력 표: 버전·날짜·수정자·주요변경 4열.",
    icon: "GitBranch",
    color: "orange",
    memo: "🎮 게임 세이브 파일 — 세이브1·세이브2·세이브3 없으면 처음부터 다시 시작이다",
    beforeLabel: "파일명 지옥",
    afterLabel: "버전 관리 체계화",
    before: "보고서_최종.pptx\n보고서_최종2.pptx\n보고서_진짜최종.pptx\n보고서_진짜최종_수정.pptx\n보고서_최최최종_팀장확인.pptx\n\n(→ 회의에서 서로 다른 버전\n발표하는 사태 발생)",
    after: "파일명: 영업전략_v1.0_240401.pptx\n       영업전략_v2.1_240419.pptx\n\n[변경이력]\nv1.0 | 240401 | KH | 초안\nv2.0 | 240410 | LJ | 3장 수치 수정\nv2.1 | 240419 | KH | 팀장 피드백 반영\n\n(→ 누가, 언제, 무엇을 바꿨는지)",
  },

  {
    id: 70,
    category: "협업·프로세스",
    title: "피드백은 흔적으로 남겨라",
    subtitle: "구두 지시는 사라지고, 기록된 피드백은 남는다",
    description: "상사의 구두 피드백은 기억에서 지워지거나 왜곡됩니다. 피드백을 받는 즉시 텍스트로 기록하고, 반영 후 같은 항목에 체크 표시를 남기면 오해와 재작업이 급감합니다.",
    detail: "피드백 수신 후 5분 내 '제가 이해한 내용은 ~입니다, 맞나요?' 형태로 확인 메시지 발송을 습관화하세요.",
    icon: "MessageSquare",
    color: "orange",
    memo: "🏥 처방전 원칙 — 의사 말을 기억하려 하지 말고 처방전(기록)을 받아라",
    beforeLabel: "구두 피드백 → 기억에 의존",
    afterLabel: "피드백 기록 → 반영 확인",
    before: "'결론 부분 좀 더 강하게'\n'숫자를 앞으로 빼세요'\n'3페이지 톤 바꿔요'\n\n(→ 다음날 수정본 제출)\n팀장: '이거 제가 말한 거랑\n다른데요?'\n\n(→ 서로 다른 기억으로 충돌)",
    after: "[피드백 수신 즉시 슬랙 기록]\n✅ 결론 섹션 첫 줄 임팩트 강화\n✅ 3p 수치 → 제목 바로 아래 이동\n✅ 3p 어조: 분석형→제안형\n\n[수정 후]\n'피드백 3개 모두 반영 완료.\n변경사항 v2.1로 공유드립니다.'\n\n(→ 오해 제로, 재작업 제로)",
  },

  {
    id: 71,
    category: "협업·프로세스",
    title: "공동 작성 스타일 가이드",
    subtitle: "여러 명이 쓰면 반드시 미리 룰을 정하라",
    description: "3명이 함께 보고서를 쓰면 3가지 문체·용어·숫자 형식이 혼재됩니다. 작성 전 30분 투자해 용어집·포맷 규칙·담당 파트를 정하면 마지막 통합 작업이 서너 배 빨라집니다.",
    detail: "최소 합의 항목: ①주요 용어 통일 ②숫자 단위·소수점 자릿수 ③존댓말 여부 ④파일 공유 방식.",
    icon: "Users",
    color: "orange",
    memo: "🎼 오케스트라 악보 — 지휘자 없이 각자 악보 보면 불협화음, 하나의 악보가 필요하다",
    beforeLabel: "사전 합의 없이 분업",
    afterLabel: "스타일 가이드 먼저 합의",
    before: "A파트: '어]무너진다', 경어체\nB파트: '무너짐', 평어체\nC파트: '崩壊될 수 있음', 한자混用\n\n수치: A→'약 30%', B→'29.7%',\n       C→'30퍼센트'\n\n(→ 최종 통합에 3시간 추가 소요)",
    after: "[작성 전 15분 규칙 합의]\n• 어조: 경어체 통일\n• 수치: 소수점 1자리, 단위 '억원'\n• 주요 용어: '매출' (수익 X)\n• KPI: '전년비' (YoY X)\n\n(→ 통합 시 수정 건수 80% 감소)",
  },

  // ══════════════════════════════════════════
  // 🧠 메타인지 (3개)
  // ══════════════════════════════════════════
  {
    id: 72,
    category: "메타인지",
    title: "확증 편향을 경계하라",
    subtitle: "결론 먼저 정해놓고 데이터를 끼워맞추지 마라",
    description: "결론을 먼저 정한 뒤 이를 지지하는 데이터만 선택하는 것이 확증 편향입니다. 보고서의 가장 위험한 함정이며, 의사결정을 망치는 가장 흔한 원인입니다.",
    detail: "작성 전 '이 결론이 틀렸다면 어떤 데이터가 나와야 하는가?'를 먼저 질문해 보세요.",
    icon: "AlertTriangle",
    color: "fuchsia",
    memo: "🔮 점쟁이 함정 — 맞추고 싶은 예언에 맞는 별자리만 골라 보는 것",
    beforeLabel: "확증 편향 보고서",
    afterLabel: "반증 테스트 후 결론",
    before: "결론: 'A제품 출시 추진'\n\n선택된 데이터:\n• 설문 긍정 응답 62%\n• 유사 제품 성공 사례 2건\n• 내부 팀 지지도 높음\n\n무시된 데이터:\n• 경쟁사 3사 동일 제품 실패\n• 원가율 78% (한계 초과)\n(→ 망한 의사결정 가능성)",
    after: "가설: 'A제품 출시 타당한가?'\n\n[지지 데이터] 설문 62% 긍정\n[반증 데이터] 경쟁사 실패 3건,\n원가율 78% 초과\n\n→ 반증 데이터까지 검토 시\n'원가 구조 개선 선행 후\n6개월 내 재검토' 결론 도출\n\n(→ 현실 기반 의사결정)",
  },

  {
    id: 73,
    category: "메타인지",
    title: "숫자의 맥락화",
    subtitle: "단독 수치는 반쪽짜리다, 비교 대상이 있어야 의미가 생긴다",
    description: "영업이익 300억 원은 그 자체로 좋은지 나쁜지 알 수 없습니다. 전년 대비, 업계 평균 대비, 목표 대비 등 비교 기준이 있어야 비로소 의미 있는 수치가 됩니다.",
    detail: "수치 옆에 항상 '기준: 전년비 +X%, 업계 평균 Y%' 형태로 맥락을 붙이세요.",
    icon: "BarChart2",
    color: "fuchsia",
    memo: "🌡️ 온도계 원칙 — 36.5°C는 정상, 그런데 어제 38°C였다면? 비교가 판단을 만든다",
    beforeLabel: "맥락 없는 단독 수치",
    afterLabel: "비교 기준과 함께 제시",
    before: "3분기 영업이익: 312억 원\n매출: 2,840억 원\n영업이익률: 11.0%\n\n(→ 이게 잘한 건가요?\n    못한 건가요?\n    판단 불가능)",
    after: "3분기 영업이익: 312억 원\n• 전년 동기比: +23% ▲ (호조)\n• 목표 대비:    +8%  ▲ (초과)\n• 업계 평균:    8.2% (당사 11.0%)\n→ 업계 2위권 실적 달성\n\n(→ 수치 하나로 3가지 판단 가능)",
  },

  {
    id: 74,
    category: "메타인지",
    title: "\"모른다\"고 쓰는 용기",
    subtitle: "불확실성을 명시하는 것이 가장 정직한 분석이다",
    description: "불확실한 부분을 억지로 채운 분석보다 '이 부분은 현재 데이터로 판단 불가'라고 명시하는 것이 더 신뢰받습니다. 전문가는 자신이 모르는 것의 경계를 안다는 것으로 신뢰를 얻습니다.",
    detail: "불확실 항목엔 '현재 데이터 부족으로 판단 유보, 추가 조사 필요' 또는 '가정: ~일 경우에만 유효' 문구를 명시하세요.",
    icon: "HelpCircle",
    color: "fuchsia",
    memo: "🗺️ 옛날 지도의 공백 — 탐험가들은 모르는 땅에 'Here be dragons' 라고 솔직히 표시했다",
    beforeLabel: "불확실성 숨기기",
    afterLabel: "불확실성 명시 + 조건 제시",
    before: "내년 시장 규모: 4.2조 원\n성장률: 12.3% 예상\n\n(실제론 추정 근거 빈약,\n경쟁사 동향 불명확한 상황에서\n단순 트렌드 연장선 예측)\n\n(→ 6개월 후 실제치 1.8조\n    → 보고서 신뢰 붕괴)",
    after: "내년 시장 규모 추정: 3~5조 원\n(불확실성 높음 ★★★)\n\n가정: 금리 동결 + 경쟁사 신제품\n미출시 조건에서만 유효\n\n현재 판단 불가 항목:\n• 해외 업체 진입 시기\n• 정부 규제 변화 방향\n→ 2025년 Q1 재검토 예정\n\n(→ 솔직한 전제가 신뢰를 만든다)",
  },



  // ══════════════════════════════════════════
  // 🧠 핵심 논리 — 추가 (2개)
  // ══════════════════════════════════════════
  {
    id: 75,
    category: "핵심 논리",
    title: "이슈 트리로 문제를 가지치기하라",
    subtitle: "질문을 쪼개면 답이 보인다",
    description: "하나의 큰 문제를 'Issue Tree'로 가지치기하면 공백이나 중복 없이 전체 문제 공간을 덮을 수 있습니다. 답을 찾기 전에 '올바른 질문'을 찾는 것이 먼저입니다.",
    detail: "이슈 트리는 수평(같은 층)의 MECE + 수직(위아래)의 So-Because 점검을 동시에 만족해야 합니다.",
    icon: "GitMerge",
    color: "indigo",
    memo: "🌳 나무 가지치기 — 큰 줄기에서 잔가지까지 다 뻗어야 빠진 곳이 없다",
    beforeLabel: "뭉뚱그려진 문제 정의",
    afterLabel: "이슈 트리로 분해",
    before: "문제: '매출이 떨어지고 있다'\n\n→ 대책을 바로 논의 시작\n→ 진짜 원인이 뭔지 합의 없음\n→ 팀마다 다른 방향 대책 제시\n→ 회의 2시간, 결론 없음",
    after: "매출 하락\n├─ 고객 수 감소?\n│   ├─ 신규 고객 유입 감소\n│   └─ 기존 고객 이탈 증가\n└─ 객단가 하락?\n    ├─ 상품 Mix 변화\n    └─ 가격 인하 압력\n\n→ '기존 고객 이탈'이 핵심으로 확인\n→ 집중할 방향 합의 10분",
  },

  {
    id: 76,
    category: "핵심 논리",
    title: "한 줄 결론을 먼저 정하라",
    subtitle: "보고서 전체를 20자로 요약하면 무엇인가?",
    description: "보고서를 쓰기 전에 '이 문서의 핵심 메시지를 한 줄로 표현하면?' 을 먼저 정해야 합니다. 이 한 줄이 없으면 아무리 많은 데이터를 넣어도 독자는 핵심을 못 잡습니다.",
    detail: "한 줄 결론 테스트: 동료에게 보고서 주제를 말하고 '결론은?'이라고 물었을 때 한 문장으로 답할 수 없다면 아직 덜 된 것입니다.",
    icon: "Target",
    color: "indigo",
    memo: "🎯 다트 과녁 — 던지기 전에 어느 원을 맞출지 정해놔야 한다",
    beforeLabel: "결론 없이 작성 시작",
    afterLabel: "한 줄 결론 확정 후 작성",
    before: "보고서 16페이지 완성 후\n팀장에게 제출\n\n팀장: '그래서 결론이 뭔가요?'\n작성자: '4페이지와 11페이지를\n같이 보시면...'\n\n(→ 결론이 흩어져 있음)",
    after: "[작성 전 1분 결론 정의]\n'B 공급사 전환 시 연간 2.4억\n절감 가능, 즉시 전환 건의'\n\n→ 이 문장을 보고서 1페이지\n   첫 줄에 놓고 역순으로 작성\n\n(→ 독자는 1초에 핵심 파악)",
  },

  // ══════════════════════════════════════════
  // 🏗️ 문서 구조 — 추가 (2개)
  // ══════════════════════════════════════════
  {
    id: 77,
    category: "문서 구조",
    title: "Executive Summary 5요소",
    subtitle: "임원이 읽는 요약문에는 반드시 이 5가지가 있어야 한다",
    description: "Executive Summary는 축약본이 아닙니다. ①배경 ②핵심 발견 ③결론·제안 ④기대 효과 ⑤필요한 결정 — 이 5가지가 모두 반 페이지 안에 들어가야 합니다.",
    detail: "임원은 Executive Summary만 읽고 결재 여부를 판단합니다. 5요소 중 하나라도 빠지면 '다시 가져오세요'가 됩니다.",
    icon: "FileText",
    color: "cyan",
    memo: "🍱 프리미엄 도시락 — 반찬 5가지가 모두 완성도 있어야 한 상이다",
    beforeLabel: "그냥 요약 (절반만 있음)",
    afterLabel: "5요소 완성 Executive Summary",
    before: "요약: 올해 마케팅 예산을\n효율적으로 사용하기 위해\n디지털 채널 중심으로 전환하고\n전통 채널은 줄이는 방향으로\n검토하고 있습니다.\n\n(→ 배경만 있고 結論·效果 없음\n  결재자: '그래서 뭘 해달라고?')",
    after: "① 배경: 마케팅 ROI 업계 최저\n② 발견: 디지털 채널 CPL 62% 저렴\n③ 제안: 예산 구성 디지털 70% 전환\n④ 효과: 연간 리드 +34%, 비용 -18%\n⑤ 결정: 3월 내 예산 재배분 승인 요\n\n(→ 5요소 완비, 30초 내 판단 가능)",
  },

  {
    id: 78,
    category: "문서 구조",
    title: "들여쓰기 계층은 3단계까지만",
    subtitle: "4단계 이상 들여쓰기는 독자를 미로에 빠뜨린다",
    description: "글머리 기호(bullet)를 3단계 이상 들여쓰면 독자는 구조를 잃고 내용보다 형식을 따라가게 됩니다. 4단계가 필요하다면 별도 섹션으로 분리하세요.",
    detail: "1단계: 핵심 요점 / 2단계: 근거·세부 / 3단계: 구체 데이터. 이 이상이 필요하면 표(Table)나 별첨으로 처리하세요.",
    icon: "AlignLeft",
    color: "cyan",
    memo: "🏢 건물 층수 — 엘리베이터 없는 건물은 3층이 한계, 그 이상은 누구도 안 올라간다",
    beforeLabel: "4단계 이상 들여쓰기",
    afterLabel: "3단계 이하 + 별첨 분리",
    before: "• 전략 방향\n  • 시장 진입\n    • 채널 선택\n      • 온라인 우선\n        • 검색 광고\n          • 키워드 선정\n\n(→ 6단계, 독자는 어디 있는지\n   완전히 길을 잃음)",
    after: "• 전략: 온라인 채널 우선 진입\n  • 근거: 타겟 연령대 80% 디지털\n  • 실행: 검색 광고 → SEO → SNS\n\n[별첨 A] 키워드 선정 기준표\n[별첨 B] 채널별 CPL 비교\n\n(→ 본문 3단계 + 별첨 상세)",
  },

  // ══════════════════════════════════════════
  // ✍️ 표현 문체 — 추가 (3개)
  // ══════════════════════════════════════════
  {
    id: 79,
    category: "표현 문체",
    title: "약어와 영어 남용 금지",
    subtitle: "ROI·CAGR·KPI — 모두 아는 거 맞나요?",
    description: "한 보고서에서 영어 약어와 외래어를 남발하면 독자 30%는 이해를 포기합니다. 첫 등장 시 풀어 쓰고, 빈번히 쓰는 약어는 표지 뒤 '용어 정의'란을 만드세요.",
    detail: "원칙: 첫 등장 시 '고객획득비용(CAC)' 형태로 병기. 이후엔 약어 사용 가능. 보고서 내 약어 5개 초과 시 용어집 추가.",
    icon: "Type",
    color: "pink",
    memo: "🌍 외국어 메뉴판 — 메뉴 이름만 영어면 주문하기 전에 포기하는 손님이 생긴다",
    beforeLabel: "약어 난무 (해독 불가)",
    afterLabel: "첫 등장 풀어쓰기 + 이후 약어",
    before: "Q3 CAC가 전분기 대비\nLTV 비율 개선에도 불구하고\nROAS 하락으로 MMM 기준\nCPL이 CAGR 목표를 하회.\nB2B SaaS 섹터 KBO 대비\nARPU 도 부진.\n\n(→ 마케팅 담당자 외 독해 불가)",
    after: "3분기 고객획득비용(CAC)은\n전분기 대비 증가했습니다.\n광고수익률(ROAS) 하락이 원인이며,\n고객생애가치(LTV) 대비 비율은\n여전히 업계 평균 이상입니다.\n\n[용어 정리]\nCAC: 고객 1인 확보 비용\nROAS: 광고비 대비 매출",
  },

  {
    id: 80,
    category: "표현 문체",
    title: "긍정형 문장으로 바꿔라",
    subtitle: "이중 부정은 두 번 생각하게 만든다",
    description: "'~하지 않으면 안 됩니다', '~가 없는 것은 아닙니다'처럼 이중 부정이나 부정형 문장은 독자에게 인지 부담을 줍니다. 같은 내용을 긍정형으로 바꾸면 명확도가 즉시 올라갑니다.",
    detail: "검토법: 문장에 '않', '없', '못', '불' 이 두 개 이상 연속으로 나오면 긍정형으로 재작성하세요.",
    icon: "CheckCircle",
    color: "pink",
    memo: "🚦 신호등 — '빨간불 아닐 때 가세요' 보다 '초록불에 가세요'가 훨씬 빠르다",
    beforeLabel: "이중 부정·부정형",
    afterLabel: "긍정형 직접 표현",
    before: "이 방안을 채택하지 않는 것은\n좋지 않을 수 있습니다.\n\n비용이 줄어들지 않는 것은 아니나,\n효과가 없다고 보기 어렵습니다.\n\n(→ 뇌가 두 번 뒤집어야 함)",
    after: "이 방안을 채택하기를 권장합니다.\n\n비용 절감 효과가 있으며,\n도입 효과는 긍정적으로 평가됩니다.\n\n(→ 읽자마자 의미가 들어옴)",
  },

  {
    id: 81,
    category: "표현 문체",
    title: "문장 첫 단어를 다양하게",
    subtitle: "연속 3문장이 같은 단어로 시작하면 지루해진다",
    description: "같은 단어나 어미로 시작하는 문장이 반복되면 보고서의 리듬이 끊기고 독자의 집중력이 떨어집니다. 다양한 접속사, 부사, 명사로 시작점을 바꾸세요.",
    detail: "완성된 단락에서 각 문장 첫 단어를 리스트로 뽑아보세요. 같은 단어가 연속 2번 이상이면 재작성 대상입니다.",
    icon: "Shuffle",
    color: "pink",
    memo: "🎵 멜로디 변주 — 같은 음표가 계속 반복되면 연주가 아니라 오류처럼 들린다",
    beforeLabel: "같은 단어 반복 시작",
    afterLabel: "다양한 시작으로 리듬 완성",
    before: "매출은 증가했습니다.\n매출은 목표를 초과했습니다.\n매출은 업계 최고치입니다.\n매출은 지속 성장 전망입니다.\n\n(→ '매출은'이 4번 반복\n   읽기 전에 지침)",
    after: "매출은 분기 목표를 12% 초과했습니다.\n특히 북미 시장이 성장을 견인했으며,\n이는 업계 최고치에 해당합니다.\n향후 성장세도 6분기 연속 유지\n전망입니다.\n\n(→ 리듬이 생겨 술술 읽힘)",
  },

  // ══════════════════════════════════════════
  // 👥 독자 중심 — 추가 (2개)
  // ══════════════════════════════════════════
  {
    id: 82,
    category: "독자 중심",
    title: "보고 전 사전 공유 전략",
    subtitle: "첫 보고가 아닌 '확인 보고'가 되게 하라",
    description: "결재 당일 보고서를 처음 보여주는 것은 가장 위험합니다. 핵심 내용을 결재 3일 전에 비공식으로 공유하면 결재 자리는 '새로운 판단' 대신 '확인과 승인'의 자리가 됩니다.",
    detail: "비공식 사전 공유 방법: 복도 대화, 이메일 1줄 요약, 점심 자리 언급 — 형식보다 '결재자가 미리 알고 있는 상태'를 만드는 것이 목적입니다.",
    icon: "BellRing",
    color: "emerald",
    memo: "🎬 영화 예고편 전략 — 개봉일에 관객이 몰리는 건 3주 전부터 예고편을 봤기 때문이다",
    beforeLabel: "당일 첫 보고 (서프라이즈)",
    afterLabel: "사전 공유 후 확인 보고",
    before: "보고 당일 아침 9시\n팀장에게 처음으로 30페이지\n보고서 공유\n\n팀장: '이건 처음 보는 내용인데,\n오늘 결재는 어렵겠네요'\n\n(→ 타이밍 실패, 다음 주로 미뤄짐)",
    after: "D-3: '팀장님, 다음 주 보고 건에서\n B안 추천 드릴 예정입니다'\n\nD-1: 슬랙으로 핵심 3줄 미리 공유\n\nD-0: '지난번 말씀드린 B안 관련\n상세 보고입니다'\n\n(→ 익숙한 내용 = 결재 속도 3배)",
  },

  {
    id: 83,
    category: "독자 중심",
    title: "반응별 대응 시나리오 준비",
    subtitle: "'그래서 그다음은?'을 미리 준비하라",
    description: "보고 중 '이 수치 근거가 뭐죠?', '다른 방안은요?', '예산이 더 필요하면?' 같은 질문이 반드시 나옵니다. 3가지 예상 반응에 대해 각각 1페이지 백업 자료를 준비하세요.",
    detail: "백업 자료 3종 세트: ①수치 근거 상세, ②대안 비교표, ③예산 시나리오별 효과 — 묻지 않으면 꺼내지 않고, 물으면 즉시 꺼낸다.",
    icon: "Map",
    color: "emerald",
    memo: "♟️ 체스 마스터 — 상대 수를 3가지 읽고 각각의 대응을 준비해놓는다",
    beforeLabel: "질문에 즉흥 대응",
    afterLabel: "시나리오별 백업 준비",
    before: "발표 중 임원 질문:\n'ROI 기준이 뭐예요?'\n\n답변: '잠깐, 계산해 보면...'\n(5분 침묵)\n'약 18%로 추정하겠습니다'\n\n(→ 준비 부족 = 신뢰 하락)",
    after: "[백업 슬라이드 B-1 준비]\nROI 산출 기준:\n투자비 2.4억, 연간 절감 0.87억\n회수기간 22개월, 3년 ROI 174%\n(업계 평균 ROI 대비 +28%)\n\n→ 질문 즉시 B-1 슬라이드 오픈\n\n(→ 준비된 답변 = 신뢰 상승)",
  },

  // ══════════════════════════════════════════
  // 📊 시각화 — 추가 (2개)
  // ══════════════════════════════════════════
  {
    id: 84,
    category: "시각화",
    title: "슬라이드 1장에 텍스트 40자 이내",
    subtitle: "글자가 많을수록 기억에 남는 것은 줄어든다",
    description: "슬라이드는 '읽는' 매체가 아니라 '보는' 매체입니다. 텍스트가 많은 슬라이드는 발표자가 낭독하게 만들고 청중의 집중을 깨뜨립니다. 비주얼이 말하고, 텍스트는 라벨만 됩니다.",
    detail: "아마존의 '파워포인트 금지' 원칙처럼, 정보 밀도가 높은 내용은 슬라이드 대신 메모(Memo) 형식의 문서로 별도 작성하세요.",
    icon: "Monitor",
    color: "rose",
    memo: "📺 광고 카피 — TV 광고 15초 안에 긴 문장 아니라 한 단어가 박힌다",
    beforeLabel: "텍스트 가득한 슬라이드",
    afterLabel: "40자 이내 + 비주얼 중심",
    before: "경쟁사 대비 우리의 위치는 시장\n점유율, 고객 만족도, 제품 품질,\n가격 경쟁력, 서비스 응답속도,\n브랜드 인지도 등 다양한 측면에서\n살펴볼 필요가 있으며...\n(→ 240자, 낭독이 시작됨)",
    after: "[큰 글씨] 6개 경쟁 지표 중\n         4개에서 1위\n\n[차트] 레이더 차트 — 우위 영역\n       시각적으로 표현\n\n(→ 발표자가 말하는 동안\n   청중이 차트를 '보는' 구조)",
  },

  {
    id: 85,
    category: "시각화",
    title: "다이어그램 vs 표, 언제 쓸까",
    subtitle: "관계는 다이어그램, 수치는 표",
    description: "다이어그램은 요소 간 관계·흐름·구조를 보여줄 때, 표는 정확한 수치를 비교할 때 씁니다. 이 둘을 혼용하면 정보가 두 곳에 나뉘어 어느 쪽도 제대로 전달이 안 됩니다.",
    detail: "다이어그램 → 프로세스, 원인-결과, 조직 구조, 아키텍처. 표 → KPI 비교, 기간별 수치, 옵션 비교.",
    icon: "Network",
    color: "rose",
    memo: "🗺️ 지도 vs 시간표 — 가는 길은 지도, 도착 시각은 시간표, 둘이 뒤바뀌면 헷갈린다",
    beforeLabel: "잘못된 시각화 선택",
    afterLabel: "목적에 맞는 시각화",
    before: "프로세스 5단계를 표(Table)로\n표현 → 흐름이 안 보임\n\n부서별 예산을 순서도(Flow chart)로\n표현 → 수치 비교가 안 됨\n\n(→ 정보 전달 실패)",
    after: "[프로세스] 화살표 다이어그램\n기획→설계→개발→테스트→배포\n  3주   4주   8주   2주   1주\n\n[예산 비교] 표\n부서 | 예산 | 전년비 | 집행률\n마케팅 | 3.2억 | +12% | 67%\n개발  | 5.8억 | -5%  | 82%\n\n(→ 각각 최적 포맷으로 명확)",
  },

  // ══════════════════════════════════════════
  // ⚡ 실전 전략 — 추가 (3개)
  // ══════════════════════════════════════════
  {
    id: 86,
    category: "실전 전략",
    title: "위기 보고서 특별 원칙",
    subtitle: "나쁜 상황일수록 더 짧고 명확하게",
    description: "위기 상황의 보고서는 분량을 늘리려는 유혹이 생깁니다(길면 성의 있어 보임). 하지만 위기일수록 ①현재 상황 ②원인 ③즉각 조치 ④타임라인 4개로 압축해야 합니다.",
    detail: "위기 보고서 황금률: 보고서가 1장을 넘으면 반으로 자르세요. 위기 때 임원은 디테일이 아닌 방향을 원합니다.",
    icon: "AlertOctagon",
    color: "amber",
    memo: "🚨 119 신고 — '언제, 어디서, 무슨 일' 세 가지만 말해도 소방차가 출동한다",
    beforeLabel: "위기 상황 장문 보고서",
    afterLabel: "4요소 1장 위기 보고서",
    before: "긴급 상황 보고서 (12페이지)\n\n1. 사건 경위 및 배경 (3p)\n2. 관련 부서 현황 분석 (3p)\n3. 원인 분석 및 검토 (3p)\n4. 대응 방안 검토 (2p)\n5. 결론 및 제언 (1p)\n\n(→ 임원이 읽기 전에 상황 악화)",
    after: "■ 현황: 서버 다운, 3,200명 결제 불가\n■ 원인: 트래픽 급증 DB 과부하 (확인)\n■ 즉각 조치:\n  [완료] 트래픽 분산 전환 12:34\n  [진행] 백업 서버 활성화 ETA 13:10\n■ 타임라인: 13:30 정상화 예상\n\n(→ 1분 보고, 즉각 판단 가능)",
  },

  {
    id: 87,
    category: "실전 전략",
    title: "실패 보고서 작성법",
    subtitle: "변명 없는 원인 분석이 다음 신뢰를 만든다",
    description: "실패나 미달 보고서에서 변명·합리화·책임 분산은 독자에게 즉시 읽힙니다. ①실제 결과 ②목표 대비 갭 ③근본 원인(외부 아닌 내부 먼저) ④재발 방지책 순으로 담으면 오히려 신뢰가 올라갑니다.",
    detail: "실패 보고서에서 가장 중요한 문장: '저희의 판단 착오는 ~이었습니다.' 먼저 내부 원인을 인정하면 외부 원인 언급도 설득력이 생깁니다.",
    icon: "TrendingDown",
    color: "amber",
    memo: "🥊 권투 선수의 패배 인터뷰 — '제가 부족했습니다'가 '심판이 잘못됐습니다'보다 다음 경기 관중을 더 모은다",
    beforeLabel: "변명 중심 실패 보고서",
    afterLabel: "원인 분석 + 재발 방지 보고서",
    before: "목표 미달 원인 분석:\n• 시장 상황이 예상과 달랐음\n• 경쟁사가 갑작스럽게 가격 인하\n• 내부 일정 지연은 불가피한 사정\n• 담당자 인력이 충분치 않았음\n\n(→ 모든 원인이 외부·남 탓)",
    after: "목표 대비 -23% 미달\n[내부 원인]\n• 초기 수요 예측 과대 추정 (+40%)\n• 개발 일정 3주 지연 (내부 조율 부재)\n[외부 요인] 경쟁사 가격 인하 영향\n\n[재발 방지]\n• 수요 예측 모델 외부 검증 프로세스\n• 주간 일정 점검 회의 신설\n\n(→ 솔직 + 대책 = 신뢰 회복)",
  },

  {
    id: 88,
    category: "실전 전략",
    title: "RAG 상태로 진행 보고하라",
    subtitle: "Red·Amber·Green 3색으로 현황을 한눈에",
    description: "프로젝트 진행 보고서에서 수백 줄의 텍스트보다 RAG(Red/Amber/Green) 신호등 체계가 훨씬 효율적입니다. 위험=빨강, 주의=노랑, 정상=초록. 임원은 빨간색만 보면 됩니다.",
    detail: "RAG 기준: Green=계획 대비 ±5% 이내 / Amber=5~15% 이탈, 자체 해결 가능 / Red=15% 이상 이탈 또는 외부 개입 필요",
    icon: "Activity",
    color: "amber",
    memo: "🚦 신호등 교통 — 초록을 일일이 확인하지 않고 빨간불만 보면 된다",
    beforeLabel: "텍스트 나열형 진행 보고",
    afterLabel: "RAG 신호등 진행 보고",
    before: "1번 과제: 현재 계획 대비 약간\n지연 중이나 큰 문제는 없으며\n다음 주 중 만회 예상\n2번 과제: 정상 진행 중\n3번 과제: 예산 소진 속도 빠름\n\n(→ 뭐가 위험한지 읽어야 앎)",
    after: "과제    상태  진행률  이슈\n─────────────────────────\n1.기획  🟢    92%   -\n2.개발  🟡    71%   일정 5일 지연\n3.마케팅 🔴   44%   예산 80% 소진\n\n→ 3번 과제: 즉각 예산 재배분 필요\n\n(→ 3초에 위험 현황 파악)",
  },

  // ══════════════════════════════════════════
  // 🧲 심리·설득 전략 — 추가 (3개)
  // ══════════════════════════════════════════
  {
    id: 89,
    category: "심리·설득 전략",
    title: "사회적 증거로 결정을 쉽게 하라",
    subtitle: "'다수가 선택한' 이라는 표현이 결정을 가속시킨다",
    description: "인간은 불확실한 상황에서 다수의 선택을 따르려는 본능이 있습니다. '업계 선도 기업 73%가 채택', '유사 프로젝트 9건 중 8건 성공' 같은 표현은 결재자의 심리적 부담을 낮춥니다.",
    detail: "사회적 증거 소재: 경쟁사·동종 업계 채택 현황, 유사 프로젝트 성공률, 전문가 단체의 권장 사례.",
    icon: "Users",
    color: "violet",
    memo: "🐧 펭귄 점프 — 첫 번째 펭귄만 망설이고, 한 마리 뛰어들면 모두 따라 뛴다",
    beforeLabel: "우리만의 주장",
    afterLabel: "사회적 증거 + 주장",
    before: "AI 기반 고객 분석 시스템\n도입을 제안합니다.\n내부 시뮬레이션상 효과가\n있을 것으로 판단됩니다.\n\n(→ '우리가 해봤다'는 것만 있음\n   결재자는 불안함)",
    after: "AI 기반 고객 분석 시스템 도입 제안\n\n• 국내 유통 상위 10사 중 7사 이미 도입\n• 동종 업계 평균 ROI 회수기간 14개월\n• 지난해 유사 시스템 도입 3사: 전원 성과\n\n→ 업계 표준으로 자리잡는 추세\n   우리가 마지막 도입 그룹\n\n(→ '남들도 하는 것'이 불안 해소)",
  },

  {
    id: 90,
    category: "심리·설득 전략",
    title: "희소성과 긴박성을 명시하라",
    subtitle: "'지금 아니면 안 된다'는 이유가 결재를 앞당긴다",
    description: "기간·수량·기회의 제한을 명확히 제시하면 결재자의 결정이 빨라집니다. '언제까지 결정해야 하는 이유'가 명확할 때, 보고서는 다음 주로 미뤄지지 않습니다.",
    detail: "긴박성 소재: 계약 마감일, 정부 보조금 신청 기한, 경쟁사보다 먼저 움직여야 하는 타이밍. 단, 허위 긴박성은 신뢰를 영구적으로 손상시킵니다.",
    icon: "Timer",
    color: "violet",
    memo: "⏳ 모래시계 — 모래가 다 내려가면 기회가 사라진다고 보여줘야 뒤집는다",
    beforeLabel: "기한 없는 제안",
    afterLabel: "긴박성 + 기한 명시",
    before: "클라우드 전환 프로젝트를\n검토해 주시기 바랍니다.\n좋은 기회라고 생각합니다.\n준비되시면 말씀해 주세요.\n\n(→ 결재자: '다음에 보자'\n   6개월 뒤 또 같은 자리)",
    after: "클라우드 전환 — 3월 31일까지 결정 필요\n\n이유:\n① AWS 프로모션 요금 4/1 종료\n   (월 340만원 → 510만원 예상)\n② 경쟁사 B, 3월 전환 완료 예정\n③ 상반기 예산 배정 마감 3/25\n\n→ 4주 내 결정 시 연 2,040만 절감\n\n(→ 수치 기반 긴박성 = 당일 결재)",
  },

  {
    id: 91,
    category: "심리·설득 전략",
    title: "호혜성 — 먼저 주는 자가 결재를 받는다",
    subtitle: "정보를 먼저 주면 도움 받고 싶은 심리가 생긴다",
    description: "보고 전에 결재자에게 '유용한 정보'를 먼저 제공하면 상대는 자연스럽게 호혜 심리가 생깁니다. '항상 좋은 정보를 주는 사람'의 보고서는 더 주의 깊게 읽히고 결재도 빨라집니다.",
    detail: "실천법: 임원이 관심 있는 업계 리포트, 경쟁사 뉴스, 유용한 통계를 보고 전날 짧게 공유하세요. '참고되실 것 같아 공유합니다' 한 줄로 충분합니다.",
    icon: "Gift",
    color: "violet",
    memo: "☕ 커피 먼저 건네는 영업사원 — 마시고 나면 5분 더 들을 마음이 생긴다",
    beforeLabel: "필요할 때만 접촉",
    afterLabel: "평소 정보 공유 → 신뢰 축적",
    before: "평소엔 연락 없다가\n보고 당일에만 등장\n\n임원: '저번에 말한 건 어떻게 됐죠?'\n작성자: '아, 그건...'\n\n(→ 평소 접촉 없음 = 관계 적립 없음\n   보고서가 낯선 사람 제안처럼 읽힘)",
    after: "D-7: '팀장님, 이번 주 업계 변화\n리포트입니다. 3페이지가 저희\n전략과 연관있어 공유드립니다'\n\nD-3: '경쟁사 A가 어제 발표한\n가격 정책 요약입니다'\n\nD-0: 보고서 제출\n→ 이미 신뢰 관계 형성된 상태\n\n(→ 낯선 제안 → 믿는 사람 제안)",
  },

  // ══════════════════════════════════════════
  // 🛡️ 신뢰·검증 — 추가 (2개)
  // ══════════════════════════════════════════
  {
    id: 92,
    category: "신뢰·검증",
    title: "가정과 전제를 명시하라",
    subtitle: "분석의 조건을 숨기면 결론이 흔들린다",
    description: "모든 분석에는 전제 조건이 있습니다. '환율 1,200원 가정', '시장 성장률 5% 유지 가정' 등 분석이 성립되는 조건을 명시하지 않으면, 조건이 바뀌었을 때 보고서 전체가 무너집니다.",
    detail: "보고서 첫 페이지 또는 분석 섹션 시작에 '본 분석의 주요 가정' 박스를 만드세요. 독자가 조건 변화를 스스로 판단할 수 있게 해줍니다.",
    icon: "ClipboardList",
    color: "teal",
    memo: "🏗️ 설계도의 지반 조사 — 지반 조건 명시 없는 설계도는 건물이 기울면 무의미해진다",
    beforeLabel: "가정 없는 분석",
    afterLabel: "가정 명시 후 분석",
    before: "2025년 예상 매출: 412억 원\n\n(산출 방식이나 전제 없음)\n\n6개월 후: 환율 급등, 원자재 폭등\n→ 실제 매출: 310억 원\n→ '보고서가 왜 틀렸나' 추궁\n\n(→ 조건 변화 대응 불가)",
    after: "[분석 주요 가정]\n• 환율: 1,320원/달러 (±5%)\n• 원자재: 전년比 +8% 가정\n• 시장성장률: 7% 유지 가정\n\n→ 2025년 예상 매출: 412억 원\n\n※ 환율 1,400원 초과 시\n   매출 380억 재산정 필요\n\n(→ 조건 변화 시 즉각 재계산 가능)",
  },

  {
    id: 93,
    category: "신뢰·검증",
    title: "제출 전 자기검증 10체크",
    subtitle: "퇴고 체크리스트가 없는 보고서는 반드시 구멍이 있다",
    description: "보고서를 완성했다고 바로 제출하지 마세요. 10개 항목의 자기검증 체크리스트를 통과한 보고서만이 '완성본'입니다. 작성자 본인이 발견하지 못한 오류는 반드시 독자가 발견합니다.",
    detail: "체크리스트 10개: ①결론이 첫 페이지에 있는가 ②수치에 출처가 있는가 ③Before/After 논리 일관성 ④오탈자 ⑤그래프 레이블 완성 ⑥페이지 순서 ⑦용어 통일 ⑧분량 적정 ⑨실행 주체 명시 ⑩날짜·기준 표기",
    icon: "ClipboardCheck",
    color: "teal",
    memo: "✈️ 이륙 전 체크리스트 — 조종사는 매번 같은 항목을 확인한다, 귀찮아서 건너뛰면 사고난다",
    beforeLabel: "직감으로 제출",
    afterLabel: "10체크 통과 후 제출",
    before: "보고서 완성!\n→ 바로 이메일 첨부 전송\n\n수신자: '3페이지 수치가 다른\n페이지 수치와 다른데요?'\n'오탈자 2개 있어요'\n'날짜 기준이 없네요'\n\n(→ 제출 후 수정 = 신뢰 하락)",
    after: "보고서 완성 후 체크리스트 5분 점검:\n☑ 결론 1페이지 배치 확인\n☑ 수치 3개 전부 출처 재확인\n☑ 용어 '매출'/'수익' 통일\n☑ 소리 내어 읽기 (어색 문장 수정)\n☑ 페이지 번호 순서 확인\n\n→ 5분 투자 = 수정 요청 0건\n\n(→ 한 번에 통과하는 보고서)",
  },

  // ══════════════════════════════════════════
  // 📱 디지털 실무 — 추가 (2개)
  // ══════════════════════════════════════════
  {
    id: 94,
    category: "디지털 실무",
    title: "파일 용량 최적화",
    subtitle: "100MB 보고서는 열리기도 전에 외면받는다",
    description: "이미지를 압축하지 않고, 고해상도 사진을 그대로 삽입하면 보고서 용량이 폭발합니다. 이메일 첨부 한도 초과, 느린 로딩, 공유 실패 — 아무리 좋은 내용도 열리지 않으면 의미가 없습니다.",
    detail: "PPT/PDF 목표 파일 크기: 이메일 첨부용 10MB 이하 / 사내 공유용 30MB 이하. 이미지는 96~150 DPI, 웹 저장 포맷 활용.",
    icon: "HardDrive",
    color: "sky",
    memo: "📦 과대 포장 택배 — 상자가 너무 크면 현관문을 못 들어온다",
    beforeLabel: "압축 없는 대용량 파일",
    afterLabel: "최적화 후 경량 파일",
    before: "보고서 PPT 파일 사이즈: 94MB\n\n이메일 첨부: 용량 제한 초과 반송\n슬랙 공유: 업로드 2분 소요\n수신자: '파일이 안 열려요'\n\n(→ 내용 보기 전 포기)",
    after: "이미지 압축 (JPEG 85% 품질)\n불필요 숨김 슬라이드 삭제\n'다른 이름으로 저장 → PDF 최적화'\n\n결과: 94MB → 8.2MB\n\n이메일 즉시 첨부, 슬랙 3초 공유\n수신자: '바로 열렸어요'\n\n(→ 내용이 먼저 읽히는 보고서)",
  },

  {
    id: 95,
    category: "디지털 실무",
    title: "접근성을 고려하라",
    subtitle: "색맹·저시력 독자도 읽을 수 있는 보고서",
    description: "색에만 의존한 정보 전달(빨간=나쁨, 초록=좋음)은 색각 이상자 약 8%에게 동일하게 보입니다. 색과 함께 패턴·레이블·아이콘을 병행하면 모든 독자에게 동일한 정보를 전달할 수 있습니다.",
    detail: "접근성 원칙 3가지: ①색과 함께 텍스트 레이블 ②그래프에 데이터 레이블 직접 표기 ③콘트라스트 비율 4.5:1 이상",
    icon: "Eye",
    color: "sky",
    memo: "🌈 색맹 교통신호 — 색만으로 신호를 구분했다면 전 세계 교통이 마비됐을 것이다",
    beforeLabel: "색에만 의존한 시각화",
    afterLabel: "색 + 레이블 + 패턴 병행",
    before: "막대 그래프:\n달성 = 초록색\n미달 = 빨간색\n(텍스트 레이블 없음)\n\n→ 적색맹 독자에게는\n  달성/미달 구분 불가\n\n(→ 일부 독자 정보 소외)",
    after: "막대 그래프:\n달성 = 초록 빗금 + '✓ 달성' 레이블\n미달 = 빨간 점선 + '✗ -23%' 레이블\n\n→ 색각 무관하게 패턴+텍스트로\n  정보 전달\n\n(→ 모든 독자가 동일하게 이해)",
  },

  // ══════════════════════════════════════════
  // 🔗 협업·프로세스 — 추가 (2개)
  // ══════════════════════════════════════════
  {
    id: 96,
    category: "협업·프로세스",
    title: "검토 요청은 구체적으로 하라",
    subtitle: "'봐주세요' 대신 '3페이지 수치 확인 부탁드립니다'",
    description: "검토를 요청할 때 '전체적으로 봐주세요'는 아무도 확인하지 않습니다. 검토자가 무엇을, 어디를, 어떤 관점으로 봐야 하는지 구체적으로 지정하면 실질적인 피드백을 받을 수 있습니다.",
    detail: "검토 요청 공식: '안녕하세요, [보고서명] 검토 부탁드립니다. 특히 ①3페이지 실적 수치 정확성, ②6페이지 결론 논리 흐름 확인 부탁드립니다. 내일까지 코멘트 주시면 감사합니다.'",
    icon: "MessageSquarePlus",
    color: "orange",
    memo: "🎯 병원 검진 — '어디 아파요?' vs '오른쪽 무릎' — 지점이 정확해야 진단이 나온다",
    beforeLabel: "막연한 검토 요청",
    afterLabel: "구체적 검토 항목 지정",
    before: "'보고서 완성했는데\n한번 봐주실 수 있나요?'\n\n동료: (전체를 어디서 어떻게\n봐야 할지 모름)\n\n결과: '전반적으로 좋아 보여요'\n→ 실질적 피드백 0\n\n(→ 제출 후 팀장 지적 3건)",
    after: "'B안 타당성 보고서 검토 부탁드립니다.\n\n📌 확인 포인트:\n① p.4 비용 계산 로직 맞는지\n② p.7 경쟁사 비교 논리 빠진 것\n③ 결론 톤이 너무 강한지\n\n오늘 오후 5시까지 주시면 감사!'\n\n→ 동료 피드백 3가지 코멘트\n\n(→ 제출 후 수정 요청 0건)",
  },

  {
    id: 97,
    category: "협업·프로세스",
    title: "보고 전 5분 리허설",
    subtitle: "소리 내어 설명해봐야 구멍이 보인다",
    description: "완성된 보고서를 동료에게 5분간 구두로 설명하세요. 설명하다 막히는 부분, 스스로 '이게 맞나?' 싶은 부분이 반드시 있습니다. 그 부분이 독자도 막히는 부분입니다.",
    detail: "혼자 할 때는 화면을 보며 소리 내어 발표 연습. 막히는 문장에 형광펜 표시 후 수정. 3회 연습 후 막히는 곳이 없으면 제출 준비 완료.",
    icon: "Mic",
    color: "orange",
    memo: "🎤 무대 공포증 치료법 — 거울 앞에서 10번 연습한 발표자는 무대에서 안 떤다",
    beforeLabel: "리허설 없이 바로 발표",
    afterLabel: "5분 리허설 후 발표",
    before: "보고서 완성 → 결재 자리\n\n발표 중: '이 부분은... 음...\n사실 좀 더 설명이 필요한데...'\n\n임원: '준비가 덜 된 것 같은데요'\n\n(→ 리허설 부족 = 신뢰 하락)",
    after: "보고 전날 5분 구두 설명:\n→ 3페이지에서 말이 막힘 발견\n→ 수치 설명 문장 보완\n→ 결론 부분 강조 포인트 추가\n\n보고 당일:\n막힘 없이 7분 발표\n임원: '잘 준비했네요'\n\n(→ 5분 투자 = 신뢰도 상승)",
  },

  // ══════════════════════════════════════════
  // �� 메타인지 — 추가 (3개)
  // ══════════════════════════════════════════
  {
    id: 98,
    category: "메타인지",
    title: "복잡성의 함정을 피하라",
    subtitle: "복잡한 보고서는 분석력이 아닌 글쓰기 실력의 문제다",
    description: "보고서가 복잡하고 어려운 이유는 두 가지입니다: 문제 자체가 복잡한 경우, 또는 작성자가 정리를 못한 경우입니다. 독자는 구분하지 못합니다. 이해하기 어려우면 둘 다 '나쁜 보고서'로 평가됩니다.",
    detail: "복잡성 자가 진단: 이 내용을 초등학생에게 설명한다면? 여전히 복잡하면 주제가 복잡한 것이고, 설명이 막히면 작성자가 덜 정리한 것입니다.",
    icon: "Zap",
    color: "fuchsia",
    memo: "�� 아인슈타인 법칙 — '6살아이에게 설명 못하면 진짜 이해한 게 아니다'",
    beforeLabel: "복잡함으로 가득한 보고서",
    afterLabel: "단순하게 정리된 보고서",
    before: "본 분석은 다차원 상관관계\n매트릭스를 기반으로 이종 데이터\n소스의 헤테로지니어스 특성을\n감안한 앙상블 방법론으로...\n\n(→ 독자: '머리가 아프다'\n   결재자: '다시 써오세요')",
    after: "3가지 데이터를 합쳐서\n어떤 고객이 이탈하는지 예측:\n\n① 최근 구매일 (3개월 이상)\n② 구매 빈도 (월 1회 미만)\n③ 불만 접수 (1건 이상)\n→ 3개 해당 시 이탈 위험 고객\n\n(→ 비전공자도 즉시 이해)",
  },

  {
    id: 99,
    category: "메타인지",
    title: "지식의 저주를 조심하라",
    subtitle: "내가 아는 것을 독자도 안다는 착각",
    description: "전문가는 자신이 당연하게 아는 것을 초보자도 안다고 착각합니다. 'KPI가 YoY로 CAGR을 하회한다'는 문장은 전문가에게 명확하지만 다른 부서 독자에게는 암호입니다. 항상 독자의 배경지식을 가정하지 마세요.",
    detail: "지식의 저주 테스트: 같은 팀 외부 사람(다른 직무, 다른 부서)에게 보고서를 읽어달라고 하고 이해 못한 부분을 표시해달라고 하세요.",
    icon: "EyeOff",
    color: "fuchsia",
    memo: "🎻 연주자의 함정 — 연주자는 머릿속에서 멜로디를 들으면서 두드리지만, 듣는 사람은 그냥 탁탁 소리만 들린다",
    beforeLabel: "전문가 관점 작성",
    afterLabel: "독자 배경 고려 작성",
    before: "Q3 DAU 기준 WAU/MAU 비율이\n목표 Stickiness Index를\n하회함에 따라 Churn Rate\nCohort 분석 결과 D-30 기준\nRetention이 ARPU 하락 요인으로...\n\n(→ 마케팅팀 담당자 외 해독 불가\n   임원 보고 자리에서 질문 폭발)",
    after: "3분기 서비스 이용 현황:\n\n• 매일 쓰는 사람: 목표 대비 -12%\n  (이유: 주 1회 이하 이용자 증가)\n\n• 한번 쓰고 떠난 사람: 전분기比 +8%\n  (이유: 신규기능 첫 경험 만족도 저하)\n\n→ 핵심 대책: 첫 1주 경험 개선\n\n(→ 어느 부서 임원도 이해 가능)",
  },

  {
    id: 100,
    category: "메타인지",
    title: "보고서 사후 회고",
    subtitle: "제출 후 한 달, 내 보고서가 어떻게 쓰였는지 추적하라",
    description: "보고서를 제출하면 끝이 아닙니다. 한 달 후 실제로 의사결정에 어떻게 활용됐는지, 예측이 맞았는지, 빠진 내용은 무엇이었는지 추적하면 다음 보고서의 품질이 급격히 올라갑니다.",
    detail: "사후 회고 3질문: ①이 보고서의 어떤 내용이 실제 결정에 쓰였나? ②어떤 내용이 틀렸고 왜 틀렸나? ③다음에 추가했으면 좋을 내용은?",
    icon: "RefreshCcw",
    color: "fuchsia",
    memo: "🌱 농부의 일기 — 씨 뿌리고 잊으면 농부가 아니다, 싹이 났는지 확인해야 다음 계절을 잘 심는다",
    beforeLabel: "제출 후 잊어버리기",
    afterLabel: "한 달 후 사후 회고",
    before: "보고서 제출 → 결재 완료\n\n6개월 후 유사 보고서 작성 시\n같은 실수 반복:\n• 수치 근거 부족 지적\n• 실행 주체 불명확 지적\n• 타임라인 누락 지적\n\n(→ 성장 없는 반복)",
    after: "[제출 1개월 후 자기 회고]\n✅ 실제 쓰인 내용: B안 비용 비교표\n❌ 안 쓰인 내용: 5페이지 경위 설명\n⚠️ 틀린 예측: 전환 비용 30% 과소\n📝 다음 추가: 리스크 시나리오 1장\n\n→ 회고 노트 1페이지 작성\n   다음 보고서 작성 전 먼저 읽음\n\n(→ 매 보고서마다 품질 한 단계 상승)",
  },


];

// ── level 주입 (AUGMENTED_PRINCIPLES) ────────────────────────────────────────
const LEVEL_MAP = {
  "핵심 논리": "must",
  "문서 구조": "must",
  "표현 문체": "recommend",
  "독자 중심": "recommend",
  "시각화": "recommend",
  "실전 전략": "must",
  "심리·설득 전략": "advanced",
    "신뢰·검증": "must",
  "디지털 실무": "recommend",
  "협업·프로세스": "recommend",
  "메타인지": "advanced",
};


// ── 단계별 분류 ─────────────────────────────────────────────────────────────
// 기획(보고서 쓰기 전) / 작성(쓰는 중) / 완성(마무리·검증) / 심화(전략·고급)
const PHASE_MAP_BY_CATEGORY = {
  '핵심 논리':    '기획',
  '독자 중심':    '기획',
  '문서 구조':    '작성',
  '표현 문체':    '작성',
  '시각화':      '작성',
  '신뢰·검증':   '완성',
  '실전 전략':   '완성',
  '협업·프로세스': '완성',
  '디지털 실무':  '완성',
  '심리·설득 전략': '심화',
  '메타인지':    '심화',
};

// ── MZ 세대 꿀팁 ─────────────────────────────────────────────────────────────
// id별로 MZ 관점 팁 (없는 id는 null)
const MZ_TIPS_BY_ID = {
  1:  "ChatGPT에 '겹치는 거나 빠진 거 없는지 체크해줘' 해보면 MECE 감 잡혀요 😊",
  2:  "유튜브 영상 구조 = 훅(결론) → 본론 → 마무리. 보고서도 똑같은 공식이에요!",
  5:  "카드뉴스 '○가지 이유' 형식이 왜 잘 읽히는지 알죠? 번호 매기기가 핵심이에요 📋",
  6:  "인스타 썸네일에 숫자 있는 게 클릭률 높듯, 숫자로 시작하는 보고서가 읽혀요 🔢",
  7:  "TL;DR 문화! 결론을 앞에 두는 게 현대 보고의 핵심이에요. MZ 스타일이 맞아요 ⚡",
  10: "인스타 피드 제목처럼 스크롤 멈추게 하는 한 줄 제목이 필요해요 👀",
  14: "유튜브 썸네일에 텍스트 가득하면 클릭 안 하듯, 보고서도 여백이 숨 쉬게 해줘요 🌬️",
  19: "슬랙 메시지처럼 — 긴 단락 NO, 핵심 불릿 OK! 개조식이 현대인 뇌에 최적화예요 💬",
  22: "틱톡 자막 보면 다 숫자로 표현하죠? 뇌가 숫자를 글자보다 먼저 파악해요 📊",
  29: "나쁜 소식 직접 말하는 게 MZ 강점이죠. 보고서에서도 그대로 발휘하세요! 🎤",
  33: "내가 만든 릴스를 구독자 시점으로 다시 보듯, 보고서도 독자 입장으로 다시 읽어봐요 🔄",
  37: "데이터 시각화는 MZ 가장 강한 영역! 단, 예쁜 것보다 '전달되는 것'이 먼저예요 🎨",
  42: "유튜브 썸네일 색 고르듯, 차트 색도 목적 있게 써요. 예쁘다고 형광색 NO 🎯",
  44: "릴스 알고리즘처럼 타이밍이 내용만큼 중요해요. 월요일 오전 > 금요일 오후 🕐",
  49: "코드 리뷰처럼 동료 리뷰 필수! 내 눈엔 보이지 않는 오류가 꼭 있어요 👓",
  53: "비싼 것 먼저 보여주는 쇼핑몰 가격 전략이 앵커링이에요. 보고서에도 활용해요 🛒",
  55: "인스타 스토리 구성처럼 — 상황 → 갈등 → 해결 순서가 사람을 끌어들여요 📖",
  63: "팩트체크 유튜버처럼 출처를 항상 달아요. 수치 뒤에 '(출처: ○○)' 습관화 🔍",
  66: "슬랙용 요약 vs 이메일 첨부 vs 발표용 PPT — 채널마다 포맷이 달라야 해요 📱",
  67: "ChatGPT 결과 그대로 제출했다가 팩트 오류 나오는 게 제일 위험한 상황. AI는 드래프트용! 🤖",
  68: "3개월 된 밈이 구식되듯, 보고서 데이터도 유통기한 있어요. 날짜 꼭 표기! 📅",
  69: "깃허브 커밋처럼 버전 관리해요. '최종_최종_진짜최종'에서 벗어나는 법! 🗂️",
  70: "DM 피드백은 캡처해두는 것처럼 — 구두 피드백도 텍스트로 남겨요. 기억은 왜곡돼요 📸",
  73: "스탯만 보는 게이머 없죠? 상대와 비교해야 강약이 보이듯 숫자도 맥락이 필요해요 🎮",
  79: "팀 외부 사람이나 신입에게 설명한다는 마음으로. 다른 부서 임원도 읽으니까요 🌐",
  82: "인스타 스토리로 예고하고 피드 올리는 것처럼 — 보고 전 사전 예고가 승인 속도 올려요 📣",
  86: "위기 트윗처럼 — 짧고, 빠르고, 핵심만. 긴 위기 보고서는 읽히기 전에 이미 늦어요 🚨",
  87: "유튜버의 '실패 TMI' 영상이 오히려 구독자 늘리듯, 솔직한 실패 분석이 신뢰 만들어요 🤝",
  94: "고화질 사진 그냥 넣으면 100MB 돌파해요. 슬랙에 못 올라가는 보고서는 아무도 안 봄 📦",
  98: "복잡한 보고서 = 실력 있어 보이는 게 아니에요. '정리 못한 것'으로 읽혀요 😅",
  99: "내가 너무 잘 아는 것을 설명할 때, 모르는 사람 기준 '0.5배속 모드'로 전환 필수! 🔉",
};


// ── Targets 주입 ─────────────────────────────────────────────────────────────
const TARGETS_BY_CATEGORY = {
  "핵심 논리": ["기획자", "전직원"],
  "문서 구조": ["보고서 작성자", "전직원"],
  "표현 문체": ["보고서 작성자", "사원·대리"],
  "독자 중심": ["기획자", "중간관리자", "팀장"],
  "시각화": ["보고서 작성자", "프레젠터"],
  "실전 전략": ["팀장", "임원", "프로젝트매니저"],
  "심리·설득 전략": ["기획자", "영업", "리더"],
  "신뢰·검증": ["모든 작성자", "최종 검토자"],
  "디지털 실무": ["전직원", "협업팀"],
  "협업·프로세스": ["프로젝트매니저", "팀장", "협업팀"],
  "메타인지": ["시니어", "기획자", "리더"],
};

// ── Situations 주입 ───────────────────────────────────────────────────────────
const SITUATIONS_BY_CATEGORY = {
  "핵심 논리": ["보고서 기획 단계", "논리 구조 설계, 문제 정의"],
  "문서 구조": ["슬라이드 작성", "문서 뼈대 잡기"],
  "표현 문체": ["초안 다듬기", "커뮤니케이션 텍스트 작성"],
  "독자 중심": ["결재권자 보고 준비", "프레젠테이션 준비"],
  "시각화": ["데이터/통계 시각적 표현", "복잡한 정보 구조화"],
  "실전 전략": ["긴급 이슈 대응", "성공/실패 결과 보고"],
  "심리·설득 전략": ["새로운 제안서 작성", "설득이 필요한 보고"],
  "신뢰·검증": ["제출 직전 최종 검토", "외부 데이터 인용 시"],
  "디지털 실무": ["파일 압축 및 공유", "이메일 첨부"],
  "협업·프로세스": ["다수 인원 문서 작업", "피드백 교환"],
  "메타인지": ["장기적 개선 방안 모색", "프로젝트 사후 회고"],
};

export const AUGMENTED_PRINCIPLES = UNIFIED_PRINCIPLES.map((p) => ({
  ...p,
  level:  LEVEL_MAP[p.category]  ?? 'recommend',
  phase:  PHASE_MAP_BY_CATEGORY[p.category] ?? '작성',
  mzTip:  MZ_TIPS_BY_ID[p.id]    ?? null,
  targets: TARGETS_BY_CATEGORY[p.category] || ["전직원", "보고서 작성자"],
  situations: SITUATIONS_BY_CATEGORY[p.category] || ["보고서 작성 업무"],
  isChecklist: p.category === "신뢰·검증" || p.title.includes("검토") || p.title.includes("체크") || p.title.includes("확인") ? true : false,
}));

